import { jsx as c, jsxs as Y, Fragment as Ge } from "react/jsx-runtime";
import * as m from "react";
import P, { createContext as Lr, useContext as Vr, useCallback as Ce, useRef as Ke, useLayoutEffect as qr, useState as Dt, useEffect as Fn, useMemo as et } from "react";
import { clsx as Gr } from "clsx";
import { twMerge as Ur } from "tailwind-merge";
import { cva as ce } from "class-variance-authority";
import * as De from "@radix-ui/react-dialog";
import * as ut from "@radix-ui/react-toast";
import { CrossFilled as dn, MarkFilled as Zr, ExclamationMarkFilled as Qr, Calendar as Xr, Down as Jr, Time as Kr } from "@cronika/assets/icons";
import * as tt from "@radix-ui/react-tooltip";
import { Slot as eo } from "@radix-ui/react-slot";
import * as un from "@radix-ui/react-checkbox";
import * as to from "react-dom";
import { createPortal as $n } from "react-dom";
import * as Le from "@radix-ui/react-popover";
import * as Te from "@radix-ui/react-select";
import * as fn from "@radix-ui/react-switch";
import * as mt from "@radix-ui/react-accordion";
import * as ft from "@radix-ui/react-scroll-area";
import * as ge from "@radix-ui/react-dropdown-menu";
import * as St from "@radix-ui/react-tabs";
import * as It from "@radix-ui/react-avatar";
function b(...e) {
  return Ur(Gr(e));
}
const no = ce("relative flex flex-col bg-content1 rounded-lg transition-shadow", {
  variants: {
    variant: {
      solid: "border border-default-200",
      bordered: "border-2 border-default-200 bg-transparent",
      flat: "bg-default-100 border-0",
      shadow: "shadow-md border border-default-200"
    },
    radius: {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl"
    }
  },
  defaultVariants: {
    variant: "solid",
    radius: "xl"
  }
}), ro = m.forwardRef(
  ({ className: e, variant: t, radius: n, isHoverable: r, isPressable: o, isDisabled: a, fullWidth: s, ...i }, l) => /* @__PURE__ */ c(
    "div",
    {
      ref: l,
      className: b(
        no({ variant: t, radius: n }),
        r && "hover:shadow-lg ",
        o && "cursor-pointer active:scale-[0.98] transition-transform",
        a && "opacity-50 pointer-events-none",
        s && "w-full",
        e
      ),
      ...i
    }
  )
);
ro.displayName = "Card";
const oo = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c("div", { ref: n, className: b("flex flex-col space-y-1.5 p-6", e), ...t })
);
oo.displayName = "CardHeader";
const ao = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c("div", { ref: n, className: b("p-6 pt-0", e), ...t })
);
ao.displayName = "CardBody";
const so = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c("div", { ref: n, className: b("flex items-center p-6 pt-0", e), ...t })
);
so.displayName = "CardFooter";
const io = ce("inline-flex items-center gap-1 rounded-full text-sm font-medium transition-colors", {
  variants: {
    variant: {
      solid: "border border-transparent",
      dot: "border border-transparent",
      bordered: "border",
      flat: "border border-transparent"
    },
    color: {
      default: "bg-default-200 text-default-foreground",
      primary: "bg-primary/20 text-primary",
      warning: "bg-warning/20 text-warning",
      success: "bg-success/20 text-success",
      danger: "bg-danger/20 text-danger"
    },
    size: {
      sm: "text-xs px-2 py-0.5",
      md: "text-sm px-2.5 py-1",
      lg: "text-base px-3 py-1.5"
    }
  },
  defaultVariants: {
    variant: "solid",
    color: "default",
    size: "md"
  }
}), lo = {
  default: "bg-default-400",
  primary: "bg-primary",
  warning: "bg-warning",
  success: "bg-success",
  danger: "bg-danger"
}, co = m.forwardRef(
  ({ className: e, variant: t, color: n, size: r, isDisabled: o, startContent: a, endContent: s, children: i, onClose: l, ...d }, f) => /* @__PURE__ */ Y(
    "div",
    {
      ref: f,
      className: b(
        io({ variant: t, color: n, size: r }),
        o && "opacity-50 pointer-events-none",
        e
      ),
      ...d,
      children: [
        t === "dot" && /* @__PURE__ */ c("span", { className: b("h-2 w-2 rounded-full flex-shrink-0", lo[n ?? "default"]) }),
        a,
        i,
        s,
        l && /* @__PURE__ */ c("button", { type: "button", onClick: l, className: "ml-1 text-current opacity-60 hover:opacity-100", children: /* @__PURE__ */ c("svg", { className: "h-3 w-3", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }) })
      ]
    }
  )
);
co.displayName = "Chip";
const In = "overflow-hidden rounded-2xl border border-white/12 bg-[#1a1a1d]/60 shadow-[0_24px_48px_rgba(0,0,0,0.55)] backdrop-blur-xl p-4", Rn = {
  root: "w-full",
  month: "relative w-full",
  month_caption: "relative flex h-[52px] items-center justify-center px-10 pt-0.5",
  weekdays: "",
  weekday: "h-10 w-11 p-0 text-center text-[11px] font-semibold uppercase leading-none tracking-[0.08em] text-white first:pl-0 last:pr-0",
  weeks: ""
}, Bn = m.createContext({
  loading: !1,
  bodyScrollable: !1
}), Ot = m.createContext("none"), uo = m.forwardRef(
  ({ className: e, loading: t, bodyScrollable: n = !1, containerClassName: r, ...o }, a) => /* @__PURE__ */ c(Bn.Provider, { value: { loading: !!t, bodyScrollable: n }, children: /* @__PURE__ */ c(
    "div",
    {
      className: b(
        "w-full",
        n ? "h-full min-h-0 overflow-auto custom-scroll" : "overflow-x-auto",
        r
      ),
      children: /* @__PURE__ */ c("table", { ref: a, className: b("w-full text-sm", e), ...o })
    }
  ) })
);
uo.displayName = "Table";
const fo = m.forwardRef(
  ({ className: e, ...t }, n) => {
    const { loading: r, bodyScrollable: o } = m.useContext(Bn);
    return /* @__PURE__ */ c(Ot.Provider, { value: "header", children: /* @__PURE__ */ Y(
      "thead",
      {
        ref: n,
        className: b("relative", o && "sticky top-0 z-[1] bg-content1", e),
        ...t,
        children: [
          t.children,
          /* @__PURE__ */ c("tr", { children: /* @__PURE__ */ c("th", { colSpan: 999, className: "p-0", children: /* @__PURE__ */ c("div", { className: "relative h-[2px] w-full overflow-hidden", children: r && /* @__PURE__ */ c("div", { className: "absolute inset-0 bg-gradient-to-r from-transparent via-warning to-transparent animate-table-loading" }) }) }) })
        ]
      }
    ) });
  }
);
fo.displayName = "TableHeader";
const mo = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c(Ot.Provider, { value: "body", children: /* @__PURE__ */ c("tbody", { ref: n, className: b(e), ...t }) })
);
mo.displayName = "TableBody";
const ho = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c(Ot.Provider, { value: "footer", children: /* @__PURE__ */ c("tfoot", { ref: n, className: b("border-t border-default-300/30 text-sm font-medium", e), ...t }) })
);
ho.displayName = "TableFooter";
const po = m.forwardRef(
  ({ className: e, ...t }, n) => {
    const r = m.useContext(Ot);
    return /* @__PURE__ */ c(
      "tr",
      {
        ref: n,
        className: b(
          "border-b border-default-300/30 transition-colors last:border-0",
          r === "body" && "hover:bg-default-100/30",
          e
        ),
        ...t
      }
    );
  }
);
po.displayName = "TableRow";
const go = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c(
    "th",
    {
      ref: n,
      className: b(
        "bg-transparent text-default-500 text-xs font-medium text-left py-3 whitespace-nowrap pr-4",
        e
      ),
      ...t
    }
  )
);
go.displayName = "TableHead";
const bo = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c("td", { ref: n, className: b("py-3 whitespace-nowrap pr-4", e), ...t })
);
bo.displayName = "TableCell";
const wo = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c("caption", { ref: n, className: b("mt-4 text-sm text-default-500", e), ...t })
);
wo.displayName = "TableCaption";
const yo = ce(
  "fixed left-[50%] top-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background shadow-lg outline-none focus:outline-none focus-visible:outline-none focus-visible:ring-0 duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 overflow-hidden max-h-[calc(100vh-2rem)]",
  {
    variants: {
      size: {
        xs: "max-w-xs",
        sm: "max-w-sm",
        md: "max-w-lg",
        lg: "max-w-2xl",
        xl: "max-w-4xl",
        "2xl": "max-w-6xl",
        full: "max-w-[calc(100%-2rem)] h-[calc(100%-2rem)]"
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
        xl: "rounded-xl",
        "2xl": "rounded-2xl"
      }
    },
    defaultVariants: {
      size: "md",
      radius: "xl"
    }
  }
), fc = De.Root, mc = De.Trigger, vo = De.Portal, hc = De.Close, An = m.forwardRef(({ className: e, backdrop: t = "opaque", ...n }, r) => (m.useEffect(() => (window.dispatchEvent(new CustomEvent("app:modal-open")), () => {
  window.dispatchEvent(new CustomEvent("app:modal-close"));
}), []), /* @__PURE__ */ c(
  De.Overlay,
  {
    ref: r,
    className: b(
      "fixed inset-0 z-40 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      {
        "bg-transparent": t === "transparent",
        "bg-[var(--ui-overlay-opaque)]": t === "opaque",
        "bg-[var(--ui-overlay-blur)] backdrop-blur-sm": t === "blur"
      },
      e
    ),
    ...n
  }
)));
An.displayName = De.Overlay.displayName;
const xo = m.forwardRef(
  ({
    className: e,
    children: t,
    size: n,
    radius: r,
    backdrop: o = "opaque",
    overlayClassName: a,
    overlayStyle: s,
    hideCloseButton: i = !1,
    variant: l = "default",
    onInteractOutside: d,
    onPointerDownOutside: f,
    ...u
  }, g) => /* @__PURE__ */ Y(vo, { children: [
    /* @__PURE__ */ c(An, { backdrop: o, className: a, style: s }),
    /* @__PURE__ */ Y(
      De.Content,
      {
        ref: g,
        className: b(
          yo({ size: n, radius: r }),
          l === "gradient" && "bg-[var(--ui-surface-modal)] !border-0",
          l === "glass" && "bg-[rgba(242,242,242,0.04)] backdrop-blur-md border border-[rgba(140,140,140,0.15)]",
          l === "dark-blur" && "!bg-[rgba(20,20,22,0.04)] backdrop-blur-[20px] !border-white/[0.07]",
          e
        ),
        onInteractOutside: (p) => {
          const h = p.detail?.originalEvent?.target;
          if (h?.closest("[data-glass-datepicker]") || h?.closest("[data-combobox-dropdown]") || h?.closest("[data-indicator-style-popover]") || h?.closest("[data-radix-select-content]") || h?.closest("[data-radix-popper-content-wrapper]") || h?.closest("[role='listbox']") || h?.closest("[role='option']")) {
            p.preventDefault();
            return;
          }
          d?.(p);
        },
        onPointerDownOutside: (p) => {
          const h = p.detail?.originalEvent?.target;
          if (h?.closest("[data-glass-datepicker]") || h?.closest("[data-combobox-dropdown]") || h?.closest("[data-indicator-style-popover]") || h?.closest("[data-radix-select-content]") || h?.closest("[data-radix-popper-content-wrapper]") || h?.closest("[role='listbox']") || h?.closest("[role='option']")) {
            p.preventDefault();
            return;
          }
          f?.(p);
        },
        ...u,
        children: [
          l === "gradient" && /* @__PURE__ */ c("div", { className: "gradient-border absolute inset-0 rounded-xl pointer-events-none" }),
          t,
          !i && /* @__PURE__ */ Y(
            De.Close,
            {
              tabIndex: -1,
              className: "absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none",
              children: [
                /* @__PURE__ */ c("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }),
                /* @__PURE__ */ c("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] })
);
xo.displayName = De.Content.displayName;
const ko = ({ className: e, ...t }) => /* @__PURE__ */ c("div", { className: b("flex flex-col space-y-1.5 px-6 py-4 text-center sm:text-left", e), ...t });
ko.displayName = "ModalHeader";
const Mo = ({ className: e, ...t }) => /* @__PURE__ */ c("div", { className: b("flex flex-col-reverse gap-2 px-6 pb-6 sm:flex-row sm:justify-end", e), ...t });
Mo.displayName = "ModalFooter";
const Do = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  De.Title,
  {
    ref: n,
    className: b("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Do.displayName = De.Title.displayName;
const No = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(De.Description, { ref: n, className: b("text-sm text-muted-foreground", e), ...t }));
No.displayName = De.Description.displayName;
const So = ({ className: e, ...t }) => /* @__PURE__ */ c("div", { className: b("px-6 py-4", e), ...t });
So.displayName = "ModalBody";
const Oo = ce(
  "inline-block animate-spin rounded-full border-2 border-current border-t-transparent",
  {
    variants: {
      size: {
        sm: "h-4 w-4",
        md: "h-6 w-6",
        lg: "h-8 w-8"
      },
      color: {
        default: "text-foreground",
        primary: "text-primary",
        secondary: "text-secondary",
        success: "text-success",
        warning: "text-warning",
        danger: "text-danger",
        white: "text-[var(--ui-text-on-dark)]"
      }
    },
    defaultVariants: {
      size: "md",
      color: "default"
    }
  }
), Co = m.forwardRef(({ className: e, size: t, color: n, label: r, ...o }, a) => /* @__PURE__ */ Y("div", { ref: a, role: "status", className: b("inline-flex items-center gap-2", e), ...o, children: [
  /* @__PURE__ */ c("div", { className: b(Oo({ size: t, color: n })) }),
  r && /* @__PURE__ */ c("span", { className: "text-sm", children: r }),
  /* @__PURE__ */ c("span", { className: "sr-only", children: "Loading..." })
] }));
Co.displayName = "Spinner";
let nt = [];
const Ut = /* @__PURE__ */ new Set();
let Wo = 0;
function jn() {
  const e = [...nt];
  Ut.forEach((t) => t(e));
}
function pc(e) {
  const t = `toast-${++Wo}-${Date.now()}`, n = {
    key: t,
    title: e.title,
    description: e.description,
    mobileTitle: e.mobileTitle,
    color: e.color ?? "success",
    timeout: e.timeout ?? 7e3,
    badge: e.badge
  };
  return nt = [...nt, n], jn(), t;
}
function Rt(e) {
  nt = nt.filter((t) => t.key !== e), jn();
}
function _o(e) {
  return Ut.add(e), () => {
    Ut.delete(e);
  };
}
function To() {
  return nt;
}
const Po = ce(
  "relative flex w-80 flex-col gap-1 rounded-lg p-4 pr-10 shadow-lg overflow-visible max-lg:w-[218px] max-lg:min-h-[38px] max-lg:justify-center max-lg:py-2 max-lg:px-3 max-lg:pr-7 data-[state=open]:animate-[toast-in_0.3s_ease-out] data-[state=closed]:animate-[toast-out_0.3s_ease-in_forwards] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-transform data-[swipe=end]:animate-[toast-out_0.3s_ease-in_forwards]",
  {
    variants: {
      color: {
        success: "bg-[var(--ui-toast-success-bg)] backdrop-blur-[40px] text-foreground",
        danger: "bg-[var(--ui-toast-danger-bg)] backdrop-blur-[40px] text-foreground",
        warning: "bg-[var(--ui-toast-warning-bg)] backdrop-blur-[40px] text-foreground"
      }
    },
    defaultVariants: {
      color: "success"
    }
  }
), Eo = {
  success: "bg-[var(--ui-toast-success-progress)]",
  danger: "bg-[var(--ui-toast-danger-progress)]",
  warning: "bg-[var(--ui-toast-warning-progress)]"
}, Yo = {
  success: "text-success",
  danger: "text-danger",
  warning: "text-warning"
}, Fo = {
  success: "#17C964",
  danger: "#F31260",
  warning: "#F5A524"
}, $o = ({ toast: e }) => {
  const [t, n] = m.useState(!0), r = Eo[e.color ?? "success"], o = Yo[e.color ?? "success"];
  return m.useEffect(() => {
    if (!e.timeout || e.timeout <= 0) return;
    const a = setTimeout(() => {
      n(!1), Rt(e.key);
    }, e.timeout);
    return () => clearTimeout(a);
  }, [e.key, e.timeout]), /* @__PURE__ */ Y(
    ut.Root,
    {
      open: t,
      className: b(Po({ color: e.color })),
      duration: e.timeout,
      style: { pointerEvents: "auto" },
      onOpenChange: (a) => {
        n(a), a || Rt(e.key);
      },
      children: [
        /* @__PURE__ */ Y("div", { className: "absolute right-2 -top-2.5 flex items-center gap-1.5 z-10", children: [
          e.badge && (() => {
            const a = Fo[e.color ?? "success"];
            return /* @__PURE__ */ c(
              "span",
              {
                className: "text-[10px] font-bold px-1.5 py-0.5 leading-none border backdrop-blur-sm",
                style: {
                  color: a,
                  borderColor: a,
                  backgroundColor: `${a}26`,
                  borderRadius: "10px"
                },
                children: e.badge
              }
            );
          })(),
          /* @__PURE__ */ c(
            "button",
            {
              type: "button",
              className: "rounded-full p-0 hover:opacity-80 transition-opacity",
              "aria-label": "Close",
              onClick: () => {
                n(!1), Rt(e.key);
              },
              children: /* @__PURE__ */ c(dn, { className: b("w-5 h-5", o) })
            }
          )
        ] }),
        /* @__PURE__ */ Y("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ Y("div", { className: "shrink-0", children: [
            e.color === "success" && /* @__PURE__ */ c(Zr, { className: b("w-5.5 h-5.5 max-lg:w-[26px] max-lg:h-[26px]", o) }),
            e.color === "danger" && /* @__PURE__ */ c(dn, { className: b("w-5.5 h-5.5 max-lg:w-[26px] max-lg:h-[26px]", o) }),
            e.color === "warning" && /* @__PURE__ */ c(Qr, { className: b("w-5.5 h-5.5 max-lg:w-[26px] max-lg:h-[26px]", o) })
          ] }),
          /* @__PURE__ */ Y("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ c(ut.Title, { className: "text-sm font-semibold max-lg:text-[10px]", children: e.mobileTitle ? /* @__PURE__ */ Y(Ge, { children: [
              /* @__PURE__ */ c("span", { className: "lg:hidden", children: e.mobileTitle }),
              /* @__PURE__ */ c("span", { className: "hidden lg:inline", children: e.title })
            ] }) : e.title }),
            e.description && /* @__PURE__ */ c(ut.Description, { className: b(
              "text-sm text-foreground/80 max-lg:[@media(max-height:390px)]:text-[10px]",
              e.mobileTitle && "hidden lg:block"
            ), children: e.description })
          ] })
        ] }),
        e.timeout && e.timeout > 0 && /* @__PURE__ */ c(
          "div",
          {
            className: b("absolute top-0 left-0 h-full pointer-events-none rounded-lg z-0", r),
            style: {
              animation: `toast-progress ${e.timeout}ms linear forwards`
            }
          }
        )
      ]
    }
  );
}, Io = "toast-stack fixed z-[9999] outline-none top-[170px] right-4 w-[218px] lg:top-auto lg:bottom-4 lg:w-80", Ro = "toast-stack fixed z-[9999] outline-none top-auto bottom-2 left-auto right-56 translate-x-0 w-[218px]", Bo = "(max-height: 390px) and (max-width: 1023px)";
function Ao(e) {
  const [t, n] = m.useState(
    () => typeof window < "u" && window.matchMedia(e).matches
  );
  return m.useEffect(() => {
    if (typeof window > "u") return;
    const r = window.matchMedia(e), o = () => n(r.matches);
    return o(), r.addEventListener("change", o), () => r.removeEventListener("change", o);
  }, [e]), t;
}
const gc = ({
  children: e,
  viewportClassName: t
}) => {
  const [n, r] = m.useState(To), o = Ao(Bo);
  return m.useEffect(() => _o(r), []), /* @__PURE__ */ Y(ut.Provider, { swipeDirection: "right", children: [
    e,
    n.map((a) => /* @__PURE__ */ c($o, { toast: a }, a.key)),
    /* @__PURE__ */ c(
      ut.Viewport,
      {
        className: t ?? (o ? Ro : Io),
        style: { pointerEvents: n.length > 0 ? "auto" : "none" }
      }
    )
  ] });
}, bc = tt.Provider, jo = tt.Root, zo = tt.Trigger, zn = m.forwardRef(({ className: e, side: t = "top", align: n = "center", sideOffset: r = 4, ...o }, a) => /* @__PURE__ */ c(tt.Portal, { children: /* @__PURE__ */ c(
  tt.Content,
  {
    ref: a,
    side: t,
    align: n,
    sideOffset: r,
    className: b(
      "z-50 overflow-hidden rounded-lg bg-[var(--ui-surface-tooltip)] px-3 py-1.5 text-sm text-[var(--ui-text-on-dark)] shadow-lg animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-4 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...o
  }
) }));
zn.displayName = tt.Content.displayName;
const Ho = m.forwardRef(
  ({
    content: e,
    placement: t = "top",
    align: n = "center",
    sideOffset: r,
    alignOffset: o,
    isDisabled: a = !1,
    classNames: s,
    delay: i = 200,
    children: l,
    ...d
  }, f) => {
    if (!e || a)
      return /* @__PURE__ */ c(Ge, { children: l });
    const g = {
      top: "top",
      right: "right",
      bottom: "bottom",
      left: "left"
    }[t] || "top";
    return /* @__PURE__ */ Y(jo, { delayDuration: i, ...d, children: [
      /* @__PURE__ */ c(zo, { ref: f, asChild: !0, children: l }),
      /* @__PURE__ */ c(
        zn,
        {
          side: g,
          align: n,
          sideOffset: r,
          alignOffset: o,
          className: s,
          children: e
        }
      )
    ] });
  }
);
Ho.displayName = "Tooltip";
const Hn = ce(
  "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-pointer",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground transition-[filter] hover:brightness-130",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        "ghost-v2": "bg-default-500/15",
        link: "text-primary underline-offset-4 hover:underline",
        flat: "bg-default-100 text-default-foreground hover:bg-default-200",
        light: "bg-transparent hover:bg-default-100",
        solid: "bg-primary text-primary-foreground shadow transition-[filter] hover:brightness-130",
        bordered: "border-2 border-[var(--ui-surface-dark-border)] bg-transparent hover:bg-[var(--ui-surface-dark-hover)]",
        faded: "border border-default-200 bg-default-100 hover:bg-default-200",
        shadow: "bg-primary text-primary-foreground shadow-lg shadow-primary/50 hover:shadow-primary/40",
        dark: "bg-[var(--ui-surface-dark)] border border-[var(--ui-surface-dark-border)] text-foreground hover:bg-[var(--ui-surface-dark-hover)]",
        glass: "bg-[var(--ui-surface-glass)] backdrop-blur-sm shadow-[var(--ui-glass-shadow)] hover:bg-[var(--ui-surface-glass-hover)] disabled:bg-[var(--ui-surface-glass-disabled)]",
        glow: "text-black bg-accent-warm",
        "glow-transparent": "btn-glow-transparent",
        "glass-v2": "border border-white/15 bg-white/[0.04] backdrop-blur-[40px] text-white/70 hover:text-white hover:border-white/30 transition-colors"
      },
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4 py-2",
        lg: "h-12 px-6 text-base",
        xl: "h-[56px] px-6 text-base",
        icon: "h-10 w-10"
      },
      color: {
        default: "",
        primary: "bg-primary text-primary-foreground hover:bg-primary/90",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/90",
        success: "bg-success text-success-foreground hover:bg-success/90",
        warning: "bg-warning text-warning-foreground hover:bg-warning/90",
        danger: "bg-danger text-danger-foreground hover:bg-danger/90"
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
        xl: "rounded-[20px]",
        full: "rounded-full"
      },
      fullWidth: {
        true: "w-full"
      },
      isIconOnly: {
        true: "aspect-square p-0"
      }
    },
    compoundVariants: [
      {
        variant: "glow",
        size: "lg"
      },
      {
        variant: "glow",
        size: "xl"
      }
    ],
    defaultVariants: {
      variant: "default",
      size: "md",
      color: "default",
      radius: "md"
    }
  }
), ht = m.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    color: r,
    radius: o,
    fullWidth: a,
    isIconOnly: s,
    asChild: i = !1,
    isLoading: l = !1,
    startContent: d,
    endContent: f,
    children: u,
    disabled: g,
    ...p
  }, h) => /* @__PURE__ */ Y(
    i ? eo : "button",
    {
      className: b(Hn({ variant: t, size: n, color: r, radius: o, fullWidth: a, isIconOnly: s, className: e })),
      ref: h,
      disabled: g || l,
      ...p,
      children: [
        l && /* @__PURE__ */ Y("svg", { className: "mr-2 h-4 w-4 animate-spin", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [
          /* @__PURE__ */ c("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
          /* @__PURE__ */ c(
            "path",
            {
              className: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            }
          )
        ] }),
        !l && d,
        u,
        !l && f
      ]
    }
  )
);
ht.displayName = "Button";
const Lo = ce(
  "peer shrink-0 border border-default-300/40 bg-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-transparent",
  {
    variants: {
      size: {
        sm: "h-4 w-4 rounded-[4px]",
        md: "h-5 w-5 rounded-[5px]",
        lg: "h-6 w-6 rounded-[6px]"
      },
      color: {
        primary: "data-[state=checked]:bg-primary focus-visible:ring-primary",
        success: "data-[state=checked]:bg-success focus-visible:ring-success",
        danger: "data-[state=checked]:bg-danger focus-visible:ring-danger",
        warning: "data-[state=checked]:bg-warning focus-visible:ring-warning"
      }
    },
    defaultVariants: {
      size: "md",
      color: "primary"
    }
  }
), Vo = {
  sm: "h-3 w-3",
  md: "h-3.5 w-3.5",
  lg: "h-4 w-4"
}, qo = m.forwardRef(
  ({ className: e, size: t, color: n, label: r, description: o, children: a, isRequired: s, id: i, ...l }, d) => {
    const f = m.useId(), u = i ?? f, g = Vo[t ?? "md"], p = a ?? r, h = /* @__PURE__ */ c(
      un.Root,
      {
        ref: d,
        id: u,
        required: s,
        className: b(Lo({ size: t, color: n }), !p && e),
        ...l,
        children: /* @__PURE__ */ c(un.Indicator, { className: "flex items-center justify-center text-foreground", children: /* @__PURE__ */ c("svg", { className: g, fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 3, children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 13l4 4L19 7" }) }) })
      }
    );
    return p ? /* @__PURE__ */ Y("div", { className: b("flex items-center gap-2", e), children: [
      h,
      /* @__PURE__ */ Y("div", { className: "flex flex-col gap-0.5", children: [
        /* @__PURE__ */ c(
          "label",
          {
            htmlFor: u,
            className: "text-sm font-medium leading-none cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
            children: p
          }
        ),
        o && /* @__PURE__ */ c("p", { className: "text-xs text-default-400", children: o })
      ] })
    ] }) : h;
  }
);
qo.displayName = "Checkbox";
function Go(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var kt = { exports: {} }, Uo = kt.exports, mn;
function Ln() {
  return mn || (mn = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(Uo, (function() {
      var n = 1e3, r = 6e4, o = 36e5, a = "millisecond", s = "second", i = "minute", l = "hour", d = "day", f = "week", u = "month", g = "quarter", p = "year", h = "date", D = "Invalid Date", N = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
        var _ = ["th", "st", "nd", "rd"], M = O % 100;
        return "[" + O + (_[(M - 20) % 10] || _[M] || _[0]) + "]";
      } }, W = function(O, _, M) {
        var S = String(O);
        return !S || S.length >= _ ? O : "" + Array(_ + 1 - S.length).join(M) + O;
      }, k = { s: W, z: function(O) {
        var _ = -O.utcOffset(), M = Math.abs(_), S = Math.floor(M / 60), x = M % 60;
        return (_ <= 0 ? "+" : "-") + W(S, 2, "0") + ":" + W(x, 2, "0");
      }, m: function O(_, M) {
        if (_.date() < M.date()) return -O(M, _);
        var S = 12 * (M.year() - _.year()) + (M.month() - _.month()), x = _.clone().add(S, u), C = M - x < 0, F = _.clone().add(S + (C ? -1 : 1), u);
        return +(-(S + (M - x) / (C ? x - F : F - x)) || 0);
      }, a: function(O) {
        return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
      }, p: function(O) {
        return { M: u, y: p, w: f, d, D: h, h: l, m: i, s, ms: a, Q: g }[O] || String(O || "").toLowerCase().replace(/s$/, "");
      }, u: function(O) {
        return O === void 0;
      } }, v = "en", w = {};
      w[v] = T;
      var $ = "$isDayjsObject", L = function(O) {
        return O instanceof X || !(!O || !O[$]);
      }, B = function O(_, M, S) {
        var x;
        if (!_) return v;
        if (typeof _ == "string") {
          var C = _.toLowerCase();
          w[C] && (x = C), M && (w[C] = M, x = C);
          var F = _.split("-");
          if (!x && F.length > 1) return O(F[0]);
        } else {
          var j = _.name;
          w[j] = _, x = j;
        }
        return !S && x && (v = x), x || !S && v;
      }, I = function(O, _) {
        if (L(O)) return O.clone();
        var M = typeof _ == "object" ? _ : {};
        return M.date = O, M.args = arguments, new X(M);
      }, R = k;
      R.l = B, R.i = L, R.w = function(O, _) {
        return I(O, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
      };
      var X = (function() {
        function O(M) {
          this.$L = B(M.locale, null, !0), this.parse(M), this.$x = this.$x || M.x || {}, this[$] = !0;
        }
        var _ = O.prototype;
        return _.parse = function(M) {
          this.$d = (function(S) {
            var x = S.date, C = S.utc;
            if (x === null) return /* @__PURE__ */ new Date(NaN);
            if (R.u(x)) return /* @__PURE__ */ new Date();
            if (x instanceof Date) return new Date(x);
            if (typeof x == "string" && !/Z$/i.test(x)) {
              var F = x.match(N);
              if (F) {
                var j = F[2] - 1 || 0, Z = (F[7] || "0").substring(0, 3);
                return C ? new Date(Date.UTC(F[1], j, F[3] || 1, F[4] || 0, F[5] || 0, F[6] || 0, Z)) : new Date(F[1], j, F[3] || 1, F[4] || 0, F[5] || 0, F[6] || 0, Z);
              }
            }
            return new Date(x);
          })(M), this.init();
        }, _.init = function() {
          var M = this.$d;
          this.$y = M.getFullYear(), this.$M = M.getMonth(), this.$D = M.getDate(), this.$W = M.getDay(), this.$H = M.getHours(), this.$m = M.getMinutes(), this.$s = M.getSeconds(), this.$ms = M.getMilliseconds();
        }, _.$utils = function() {
          return R;
        }, _.isValid = function() {
          return this.$d.toString() !== D;
        }, _.isSame = function(M, S) {
          var x = I(M);
          return this.startOf(S) <= x && x <= this.endOf(S);
        }, _.isAfter = function(M, S) {
          return I(M) < this.startOf(S);
        }, _.isBefore = function(M, S) {
          return this.endOf(S) < I(M);
        }, _.$g = function(M, S, x) {
          return R.u(M) ? this[S] : this.set(x, M);
        }, _.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, _.valueOf = function() {
          return this.$d.getTime();
        }, _.startOf = function(M, S) {
          var x = this, C = !!R.u(S) || S, F = R.p(M), j = function(E, U) {
            var se = R.w(x.$u ? Date.UTC(x.$y, U, E) : new Date(x.$y, U, E), x);
            return C ? se : se.endOf(d);
          }, Z = function(E, U) {
            return R.w(x.toDate()[E].apply(x.toDate("s"), (C ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(U)), x);
          }, Q = this.$W, K = this.$M, ee = this.$D, le = "set" + (this.$u ? "UTC" : "");
          switch (F) {
            case p:
              return C ? j(1, 0) : j(31, 11);
            case u:
              return C ? j(1, K) : j(0, K + 1);
            case f:
              var ue = this.$locale().weekStart || 0, he = (Q < ue ? Q + 7 : Q) - ue;
              return j(C ? ee - he : ee + (6 - he), K);
            case d:
            case h:
              return Z(le + "Hours", 0);
            case l:
              return Z(le + "Minutes", 1);
            case i:
              return Z(le + "Seconds", 2);
            case s:
              return Z(le + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, _.endOf = function(M) {
          return this.startOf(M, !1);
        }, _.$set = function(M, S) {
          var x, C = R.p(M), F = "set" + (this.$u ? "UTC" : ""), j = (x = {}, x[d] = F + "Date", x[h] = F + "Date", x[u] = F + "Month", x[p] = F + "FullYear", x[l] = F + "Hours", x[i] = F + "Minutes", x[s] = F + "Seconds", x[a] = F + "Milliseconds", x)[C], Z = C === d ? this.$D + (S - this.$W) : S;
          if (C === u || C === p) {
            var Q = this.clone().set(h, 1);
            Q.$d[j](Z), Q.init(), this.$d = Q.set(h, Math.min(this.$D, Q.daysInMonth())).$d;
          } else j && this.$d[j](Z);
          return this.init(), this;
        }, _.set = function(M, S) {
          return this.clone().$set(M, S);
        }, _.get = function(M) {
          return this[R.p(M)]();
        }, _.add = function(M, S) {
          var x, C = this;
          M = Number(M);
          var F = R.p(S), j = function(K) {
            var ee = I(C);
            return R.w(ee.date(ee.date() + Math.round(K * M)), C);
          };
          if (F === u) return this.set(u, this.$M + M);
          if (F === p) return this.set(p, this.$y + M);
          if (F === d) return j(1);
          if (F === f) return j(7);
          var Z = (x = {}, x[i] = r, x[l] = o, x[s] = n, x)[F] || 1, Q = this.$d.getTime() + M * Z;
          return R.w(Q, this);
        }, _.subtract = function(M, S) {
          return this.add(-1 * M, S);
        }, _.format = function(M) {
          var S = this, x = this.$locale();
          if (!this.isValid()) return x.invalidDate || D;
          var C = M || "YYYY-MM-DDTHH:mm:ssZ", F = R.z(this), j = this.$H, Z = this.$m, Q = this.$M, K = x.weekdays, ee = x.months, le = x.meridiem, ue = function(U, se, be, Se) {
            return U && (U[se] || U(S, C)) || be[se].slice(0, Se);
          }, he = function(U) {
            return R.s(j % 12 || 12, U, "0");
          }, E = le || function(U, se, be) {
            var Se = U < 12 ? "AM" : "PM";
            return be ? Se.toLowerCase() : Se;
          };
          return C.replace(y, (function(U, se) {
            return se || (function(be) {
              switch (be) {
                case "YY":
                  return String(S.$y).slice(-2);
                case "YYYY":
                  return R.s(S.$y, 4, "0");
                case "M":
                  return Q + 1;
                case "MM":
                  return R.s(Q + 1, 2, "0");
                case "MMM":
                  return ue(x.monthsShort, Q, ee, 3);
                case "MMMM":
                  return ue(ee, Q);
                case "D":
                  return S.$D;
                case "DD":
                  return R.s(S.$D, 2, "0");
                case "d":
                  return String(S.$W);
                case "dd":
                  return ue(x.weekdaysMin, S.$W, K, 2);
                case "ddd":
                  return ue(x.weekdaysShort, S.$W, K, 3);
                case "dddd":
                  return K[S.$W];
                case "H":
                  return String(j);
                case "HH":
                  return R.s(j, 2, "0");
                case "h":
                  return he(1);
                case "hh":
                  return he(2);
                case "a":
                  return E(j, Z, !0);
                case "A":
                  return E(j, Z, !1);
                case "m":
                  return String(Z);
                case "mm":
                  return R.s(Z, 2, "0");
                case "s":
                  return String(S.$s);
                case "ss":
                  return R.s(S.$s, 2, "0");
                case "SSS":
                  return R.s(S.$ms, 3, "0");
                case "Z":
                  return F;
              }
              return null;
            })(U) || F.replace(":", "");
          }));
        }, _.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, _.diff = function(M, S, x) {
          var C, F = this, j = R.p(S), Z = I(M), Q = (Z.utcOffset() - this.utcOffset()) * r, K = this - Z, ee = function() {
            return R.m(F, Z);
          };
          switch (j) {
            case p:
              C = ee() / 12;
              break;
            case u:
              C = ee();
              break;
            case g:
              C = ee() / 3;
              break;
            case f:
              C = (K - Q) / 6048e5;
              break;
            case d:
              C = (K - Q) / 864e5;
              break;
            case l:
              C = K / o;
              break;
            case i:
              C = K / r;
              break;
            case s:
              C = K / n;
              break;
            default:
              C = K;
          }
          return x ? C : R.a(C);
        }, _.daysInMonth = function() {
          return this.endOf(u).$D;
        }, _.$locale = function() {
          return w[this.$L];
        }, _.locale = function(M, S) {
          if (!M) return this.$L;
          var x = this.clone(), C = B(M, S, !0);
          return C && (x.$L = C), x;
        }, _.clone = function() {
          return R.w(this.$d, this);
        }, _.toDate = function() {
          return new Date(this.valueOf());
        }, _.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, _.toISOString = function() {
          return this.$d.toISOString();
        }, _.toString = function() {
          return this.$d.toUTCString();
        }, O;
      })(), V = X.prototype;
      return I.prototype = V, [["$ms", a], ["$s", s], ["$m", i], ["$H", l], ["$W", d], ["$M", u], ["$y", p], ["$D", h]].forEach((function(O) {
        V[O[1]] = function(_) {
          return this.$g(_, O[0], O[1]);
        };
      })), I.extend = function(O, _) {
        return O.$i || (O(_, X, I), O.$i = !0), I;
      }, I.locale = B, I.isDayjs = L, I.unix = function(O) {
        return I(1e3 * O);
      }, I.en = w[v], I.Ls = w, I.p = {}, I;
    }));
  })(kt)), kt.exports;
}
var Zo = Ln();
const $e = /* @__PURE__ */ Go(Zo);
var Mt = { exports: {} }, Qo = Mt.exports, hn;
function Xo() {
  return hn || (hn = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r(Ln());
    })(Qo, (function(n) {
      function r(h) {
        return h && typeof h == "object" && "default" in h ? h : { default: h };
      }
      var o = r(n), a = "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"), s = "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"), i = "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"), l = "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_"), d = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
      function f(h, D, N) {
        var y, T;
        return N === "m" ? D ? "минута" : "минуту" : h + " " + (y = +h, T = { mm: D ? "минута_минуты_минут" : "минуту_минуты_минут", hh: "час_часа_часов", dd: "день_дня_дней", MM: "месяц_месяца_месяцев", yy: "год_года_лет" }[N].split("_"), y % 10 == 1 && y % 100 != 11 ? T[0] : y % 10 >= 2 && y % 10 <= 4 && (y % 100 < 10 || y % 100 >= 20) ? T[1] : T[2]);
      }
      var u = function(h, D) {
        return d.test(D) ? a[h.month()] : s[h.month()];
      };
      u.s = s, u.f = a;
      var g = function(h, D) {
        return d.test(D) ? i[h.month()] : l[h.month()];
      };
      g.s = l, g.f = i;
      var p = { name: "ru", weekdays: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"), weekdaysShort: "вск_пнд_втр_срд_чтв_птн_сбт".split("_"), weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"), months: u, monthsShort: g, weekStart: 1, yearStart: 4, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY г.", LLL: "D MMMM YYYY г., H:mm", LLLL: "dddd, D MMMM YYYY г., H:mm" }, relativeTime: { future: "через %s", past: "%s назад", s: "несколько секунд", m: f, mm: f, h: "час", hh: f, d: "день", dd: f, M: "месяц", MM: f, y: "год", yy: f }, ordinal: function(h) {
        return h;
      }, meridiem: function(h) {
        return h < 4 ? "ночи" : h < 12 ? "утра" : h < 17 ? "дня" : "вечера";
      } };
      return o.default.locale(p, null, !0), p;
    }));
  })(Mt)), Mt.exports;
}
Xo();
function Jo(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const Ko = {}, ct = {};
function qe(e, t) {
  try {
    const r = (Ko[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return r in ct ? ct[r] : pn(r, r.split(":"));
  } catch {
    if (e in ct) return ct[e];
    const n = e?.match(ea);
    return n ? pn(e, n.slice(1)) : NaN;
  }
}
const ea = /([+-]\d\d):?(\d\d)?/;
function pn(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return ct[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class Ie extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(qe(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), Vn(this), Zt(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Ie(...n, t) : new Ie(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Ie(+this, t);
  }
  getTimezoneOffset() {
    const t = -qe(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), Zt(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new Ie(+new Date(t), this.timeZone);
  }
  //#endregion
}
const gn = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!gn.test(e)) return;
  const t = e.replace(gn, "$1UTC");
  Ie.prototype[t] && (e.startsWith("get") ? Ie.prototype[e] = function() {
    return this.internal[t]();
  } : (Ie.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), ta(this), +this;
  }, Ie.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), Zt(this), +this;
  }));
});
function Zt(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-qe(e.timeZone, e) * 60));
}
function ta(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Vn(e);
}
function Vn(e) {
  const t = qe(e.timeZone, e), n = t > 0 ? Math.floor(t) : Math.ceil(t), r = /* @__PURE__ */ new Date(+e);
  r.setUTCHours(r.getUTCHours() - 1);
  const o = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), s = o - a, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  s && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + s);
  const l = o - n;
  l && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + l);
  const d = /* @__PURE__ */ new Date(+e);
  d.setUTCSeconds(0);
  const f = o > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, u = Math.round(-(qe(e.timeZone, e) * 60)) % 60;
  (u || f) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + u), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + u + f));
  const g = qe(e.timeZone, e), p = g > 0 ? Math.floor(g) : Math.ceil(g), D = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - p, N = p !== n, y = D - l;
  if (N && y) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y);
    const T = qe(e.timeZone, e), W = T > 0 ? Math.floor(T) : Math.ceil(T), k = p - W;
    k && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + k), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + k));
  }
}
class me extends Ie {
  //#region static
  static tz(t, ...n) {
    return n.length ? new me(...n, t) : new me(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${Jo(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new me(+this, t);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new me(+new Date(t), this.timeZone);
  }
  //#endregion
}
const qn = 6048e5, na = 864e5, bn = /* @__PURE__ */ Symbol.for("constructDateFrom");
function de(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && bn in e ? e[bn](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function oe(e, t) {
  return de(t || e, e);
}
function Gn(e, t, n) {
  const r = oe(e, n?.in);
  return isNaN(t) ? de(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Un(e, t, n) {
  const r = oe(e, n?.in);
  if (isNaN(t)) return de(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), a = de(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const s = a.getDate();
  return o >= s ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    o
  ), r);
}
let ra = {};
function bt() {
  return ra;
}
function rt(e, t) {
  const n = bt(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = oe(e, t?.in), a = o.getDay(), s = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function pt(e, t) {
  return rt(e, { ...t, weekStartsOn: 1 });
}
function Zn(e, t) {
  const n = oe(e, t?.in), r = n.getFullYear(), o = de(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = pt(o), s = de(n, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const i = pt(s);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= i.getTime() ? r : r - 1;
}
function wn(e) {
  const t = oe(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function ot(e, ...t) {
  const n = de.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function gt(e, t) {
  const n = oe(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Qt(e, t, n) {
  const [r, o] = ot(
    n?.in,
    e,
    t
  ), a = gt(r), s = gt(o), i = +a - wn(a), l = +s - wn(s);
  return Math.round((i - l) / na);
}
function oa(e, t) {
  const n = Zn(e, t), r = de(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), pt(r);
}
function aa(e, t, n) {
  return Gn(e, t * 7, n);
}
function sa(e, t, n) {
  return Un(e, t * 12, n);
}
function ia(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = de.bind(null, o));
    const a = oe(o, r);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), de(r, n || NaN);
}
function la(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = de.bind(null, o));
    const a = oe(o, r);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), de(r, n || NaN);
}
function ca(e, t, n) {
  const [r, o] = ot(
    n?.in,
    e,
    t
  );
  return +gt(r) == +gt(o);
}
function Qn(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function da(e) {
  return !(!Qn(e) && typeof e != "number" || isNaN(+oe(e)));
}
function Xn(e, t, n) {
  const [r, o] = ot(
    n?.in,
    e,
    t
  ), a = r.getFullYear() - o.getFullYear(), s = r.getMonth() - o.getMonth();
  return a * 12 + s;
}
function ua(e, t) {
  const n = oe(e, t?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Jn(e, t) {
  const [n, r] = ot(e, t.start, t.end);
  return { start: n, end: r };
}
function fa(e, t) {
  const { start: n, end: r } = Jn(t?.in, e);
  let o = +n > +r;
  const a = o ? +n : +r, s = o ? r : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let i = 1;
  const l = [];
  for (; +s <= a; )
    l.push(de(n, s)), s.setMonth(s.getMonth() + i);
  return o ? l.reverse() : l;
}
function ma(e, t) {
  const n = oe(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function ha(e, t) {
  const n = oe(e, t?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Kn(e, t) {
  const n = oe(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function pa(e, t) {
  const { start: n, end: r } = Jn(t?.in, e);
  let o = +n > +r;
  const a = o ? +n : +r, s = o ? r : n;
  s.setHours(0, 0, 0, 0), s.setMonth(0, 1);
  let i = 1;
  const l = [];
  for (; +s <= a; )
    l.push(de(n, s)), s.setFullYear(s.getFullYear() + i);
  return o ? l.reverse() : l;
}
function er(e, t) {
  const n = bt(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = oe(e, t?.in), a = o.getDay(), s = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + s), o.setHours(23, 59, 59, 999), o;
}
function ga(e, t) {
  return er(e, { ...t, weekStartsOn: 1 });
}
const ba = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, wa = (e, t, n) => {
  let r;
  const o = ba[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Bt(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const ya = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, va = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xa = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ka = {
  date: Bt({
    formats: ya,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: va,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: xa,
    defaultWidth: "full"
  })
}, Ma = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Da = (e, t, n, r) => Ma[e];
function st(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, i = n?.width ? String(n.width) : s;
      o = e.formattingValues[i] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, i = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[i] || e.values[s];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const Na = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Sa = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Oa = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ca = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Wa = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, _a = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ta = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Pa = {
  ordinalNumber: Ta,
  era: st({
    values: Na,
    defaultWidth: "wide"
  }),
  quarter: st({
    values: Sa,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: st({
    values: Oa,
    defaultWidth: "wide"
  }),
  day: st({
    values: Ca,
    defaultWidth: "wide"
  }),
  dayPeriod: st({
    values: Wa,
    defaultWidth: "wide",
    formattingValues: _a,
    defaultFormattingWidth: "wide"
  })
};
function it(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const s = a[0], i = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(i) ? Ya(i, (u) => u.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      Ea(i, (u) => u.test(s))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(s.length);
    return { value: d, rest: f };
  };
}
function Ea(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Ya(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Fa(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let s = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const i = t.slice(o.length);
    return { value: s, rest: i };
  };
}
const $a = /^(\d+)(th|st|nd|rd)?/i, Ia = /\d+/i, Ra = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ba = {
  any: [/^b/i, /^(a|c)/i]
}, Aa = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ja = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, za = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ha = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, La = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Va = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, qa = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ga = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Ua = {
  ordinalNumber: Fa({
    matchPattern: $a,
    parsePattern: Ia,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: it({
    matchPatterns: Ra,
    defaultMatchWidth: "wide",
    parsePatterns: Ba,
    defaultParseWidth: "any"
  }),
  quarter: it({
    matchPatterns: Aa,
    defaultMatchWidth: "wide",
    parsePatterns: ja,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: it({
    matchPatterns: za,
    defaultMatchWidth: "wide",
    parsePatterns: Ha,
    defaultParseWidth: "any"
  }),
  day: it({
    matchPatterns: La,
    defaultMatchWidth: "wide",
    parsePatterns: Va,
    defaultParseWidth: "any"
  }),
  dayPeriod: it({
    matchPatterns: qa,
    defaultMatchWidth: "any",
    parsePatterns: Ga,
    defaultParseWidth: "any"
  })
}, Je = {
  code: "en-US",
  formatDistance: wa,
  formatLong: ka,
  formatRelative: Da,
  localize: Pa,
  match: Ua,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Za(e, t) {
  const n = oe(e, t?.in);
  return Qt(n, Kn(n)) + 1;
}
function Xt(e, t) {
  const n = oe(e, t?.in), r = +pt(n) - +oa(n);
  return Math.round(r / qn) + 1;
}
function tr(e, t) {
  const n = oe(e, t?.in), r = n.getFullYear(), o = bt(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = de(t?.in || e, 0);
  s.setFullYear(r + 1, 0, a), s.setHours(0, 0, 0, 0);
  const i = rt(s, t), l = de(t?.in || e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const d = rt(l, t);
  return +n >= +i ? r + 1 : +n >= +d ? r : r - 1;
}
function Qa(e, t) {
  const n = bt(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = tr(e, t), a = de(t?.in || e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), rt(a, t);
}
function Jt(e, t) {
  const n = oe(e, t?.in), r = +rt(n, t) - +Qa(n, t);
  return Math.round(r / qn) + 1;
}
function re(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const He = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return re(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : re(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return re(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return re(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return re(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return re(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return re(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return re(o, t.length);
  }
}, Ze = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, yn = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return He.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = tr(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = a % 100;
      return re(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : re(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Zn(e);
    return re(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return re(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return re(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return re(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return He.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return re(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = Jt(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : re(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Xt(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : re(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : He.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Za(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : re(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return re(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return re(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return re(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Ze.noon : r === 0 ? o = Ze.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Ze.evening : r >= 12 ? o = Ze.afternoon : r >= 4 ? o = Ze.morning : o = Ze.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return He.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : He.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : re(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : re(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : He.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : He.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return He.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return xn(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ve(r);
      // Hours and minutes with `:` delimiter
      default:
        return Ve(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return xn(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ve(r);
      // Hours and minutes with `:` delimiter
      default:
        return Ve(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + vn(r, ":");
      default:
        return "GMT" + Ve(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + vn(r, ":");
      default:
        return "GMT" + Ve(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return re(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return re(+e, t.length);
  }
};
function vn(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + re(a, 2);
}
function xn(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + re(Math.abs(e) / 60, 2) : Ve(e, t);
}
function Ve(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = re(Math.trunc(r / 60), 2), a = re(r % 60, 2);
  return n + o + t + a;
}
const kn = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, nr = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, Xa = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return kn(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", kn(r, t)).replace("{{time}}", nr(o, t));
}, Ja = {
  p: nr,
  P: Xa
}, Ka = /^D+$/, es = /^Y+$/, ts = ["D", "DD", "YY", "YYYY"];
function ns(e) {
  return Ka.test(e);
}
function rs(e) {
  return es.test(e);
}
function os(e, t, n) {
  const r = as(e, t, n);
  if (console.warn(r), ts.includes(e)) throw new RangeError(r);
}
function as(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const ss = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, is = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ls = /^'([^]*?)'?$/, cs = /''/g, ds = /[a-zA-Z]/;
function dt(e, t, n) {
  const r = bt(), o = n?.locale ?? r.locale ?? Je, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, i = oe(e, n?.in);
  if (!da(i))
    throw new RangeError("Invalid time value");
  let l = t.match(is).map((f) => {
    const u = f[0];
    if (u === "p" || u === "P") {
      const g = Ja[u];
      return g(f, o.formatLong);
    }
    return f;
  }).join("").match(ss).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const u = f[0];
    if (u === "'")
      return { isToken: !1, value: us(f) };
    if (yn[u])
      return { isToken: !0, value: f };
    if (u.match(ds))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + u + "`"
      );
    return { isToken: !1, value: f };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(i, l));
  const d = {
    firstWeekContainsDate: a,
    weekStartsOn: s,
    locale: o
  };
  return l.map((f) => {
    if (!f.isToken) return f.value;
    const u = f.value;
    (!n?.useAdditionalWeekYearTokens && rs(u) || !n?.useAdditionalDayOfYearTokens && ns(u)) && os(u, t, String(e));
    const g = yn[u[0]];
    return g(i, u, o.localize, d);
  }).join("");
}
function us(e) {
  const t = e.match(ls);
  return t ? t[1].replace(cs, "'") : e;
}
function fs(e, t) {
  const n = oe(e, t?.in), r = n.getFullYear(), o = n.getMonth(), a = de(n, 0);
  return a.setFullYear(r, o + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function ms(e, t) {
  return oe(e, t?.in).getMonth();
}
function hs(e, t) {
  return oe(e, t?.in).getFullYear();
}
function ps(e, t) {
  return +oe(e) > +oe(t);
}
function gs(e, t) {
  return +oe(e) < +oe(t);
}
function bs(e, t, n) {
  const [r, o] = ot(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function ws(e, t, n) {
  const [r, o] = ot(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function ys(e, t, n) {
  const r = oe(e, n?.in), o = r.getFullYear(), a = r.getDate(), s = de(e, 0);
  s.setFullYear(o, t, 15), s.setHours(0, 0, 0, 0);
  const i = fs(s);
  return r.setMonth(t, Math.min(a, i)), r;
}
function vs(e, t, n) {
  const r = oe(e, n?.in);
  return isNaN(+r) ? de(e, NaN) : (r.setFullYear(t), r);
}
const Mn = 5, xs = 4;
function ks(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), a = t.addDays(o, Mn * 7 - 1);
  return t.getMonth(e) === t.getMonth(a) ? Mn : xs;
}
function rr(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
function Ms(e, t) {
  const n = rr(e, t), r = ks(e, t);
  return t.addDays(n, r * 7 - 1);
}
const or = {
  ...Je,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (s, i) => dt(s, i, { locale: Je, ...n });
      let a = o(e, "PPPP");
      return t.today && (a = `Today, ${a}`), t.selected && (a = `${a}, selected`), a;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, a) => dt(o, a, { locale: Je, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (s, i) => dt(s, i, { locale: Je, ...n });
      let a = o(e, "PPPP");
      return t?.today && (a = `Today, ${a}`), a;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, a) => dt(o, a, { locale: Je, ...t }), r(e, "cccc");
    }
  }
};
class Ne {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? me.tz(this.options.timeZone) : new this.Date(), this.newDate = (r, o, a) => this.overrides?.newDate ? this.overrides.newDate(r, o, a) : this.options.timeZone ? new me(r, o, a, this.options.timeZone) : new Date(r, o, a), this.addDays = (r, o) => this.overrides?.addDays ? this.overrides.addDays(r, o) : Gn(r, o), this.addMonths = (r, o) => this.overrides?.addMonths ? this.overrides.addMonths(r, o) : Un(r, o), this.addWeeks = (r, o) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, o) : aa(r, o), this.addYears = (r, o) => this.overrides?.addYears ? this.overrides.addYears(r, o) : sa(r, o), this.differenceInCalendarDays = (r, o) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Qt(r, o), this.differenceInCalendarMonths = (r, o) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : Xn(r, o), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : fa(r), this.eachYearOfInterval = (r) => {
      const o = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : pa(r), a = new Set(o.map((i) => this.getYear(i)));
      if (a.size === o.length)
        return o;
      const s = [];
      return a.forEach((i) => {
        s.push(new Date(i, 0, 1));
      }), s;
    }, this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : Ms(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : ga(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : ua(r), this.endOfWeek = (r, o) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, o) : er(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : ha(r), this.format = (r, o, a) => {
      const s = this.overrides?.format ? this.overrides.format(r, o, this.options) : dt(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : Xt(r), this.getMonth = (r, o) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : ms(r, this.options), this.getYear = (r, o) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : hs(r, this.options), this.getWeek = (r, o) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : Jt(r, this.options), this.isAfter = (r, o) => this.overrides?.isAfter ? this.overrides.isAfter(r, o) : ps(r, o), this.isBefore = (r, o) => this.overrides?.isBefore ? this.overrides.isBefore(r, o) : gs(r, o), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : Qn(r), this.isSameDay = (r, o) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, o) : ca(r, o), this.isSameMonth = (r, o) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, o) : bs(r, o), this.isSameYear = (r, o) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, o) : ws(r, o), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : ia(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : la(r), this.setMonth = (r, o) => this.overrides?.setMonth ? this.overrides.setMonth(r, o) : ys(r, o), this.setYear = (r, o) => this.overrides?.setYear ? this.overrides.setYear(r, o) : vs(r, o), this.startOfBroadcastWeek = (r, o) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : rr(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : gt(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : pt(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : ma(r), this.startOfWeek = (r, o) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : rt(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : Kn(r), this.options = { locale: or, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && Ne.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, a = n?.code;
    if (a && Ne.yearFirstLocales.has(a))
      try {
        return new Intl.DateTimeFormat(a, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const s = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, s);
  }
}
Ne.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const Re = new Ne();
class ar {
  constructor(t, n, r = Re) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class Ds {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class Ns {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function Ss(e) {
  return P.createElement("button", { ...e });
}
function Os(e) {
  return P.createElement("span", { ...e });
}
function Cs(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    P.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && P.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && P.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && P.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && P.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function Ws(e) {
  const { day: t, modifiers: n, ...r } = e;
  return P.createElement("td", { ...r });
}
function _s(e) {
  const { day: t, modifiers: n, ...r } = e, o = P.useRef(null);
  return P.useEffect(() => {
    n.focused && o.current?.focus();
  }, [n.focused]), P.createElement("button", { ref: o, ...r });
}
var A;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(A || (A = {}));
var ie;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(ie || (ie = {}));
var Pe;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Pe || (Pe = {}));
var Me;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(Me || (Me = {}));
function Ts(e) {
  const { options: t, className: n, components: r, classNames: o, ...a } = e, s = [o[A.Dropdown], n].join(" "), i = t?.find(({ value: l }) => l === a.value);
  return P.createElement(
    "span",
    { "data-disabled": a.disabled, className: o[A.DropdownRoot] },
    P.createElement(r.Select, { className: s, ...a }, t?.map(({ value: l, label: d, disabled: f }) => P.createElement(r.Option, { key: l, value: l, disabled: f }, d))),
    P.createElement(
      "span",
      { className: o[A.CaptionLabel], "aria-hidden": !0 },
      i?.label,
      P.createElement(r.Chevron, { orientation: "down", size: 18, className: o[A.Chevron] })
    )
  );
}
function Ps(e) {
  return P.createElement("div", { ...e });
}
function Es(e) {
  return P.createElement("div", { ...e });
}
function Ys(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return P.createElement("div", { ...r }, e.children);
}
function Fs(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return P.createElement("div", { ...r });
}
function $s(e) {
  return P.createElement("table", { ...e });
}
function Is(e) {
  return P.createElement("div", { ...e });
}
const sr = Lr(void 0);
function wt() {
  const e = Vr(sr);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function Rs(e) {
  const { components: t } = wt();
  return P.createElement(t.Dropdown, { ...e });
}
function Bs(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...a } = e, { components: s, classNames: i, labels: { labelPrevious: l, labelNext: d } } = wt(), f = Ce((g) => {
    o && n?.(g);
  }, [o, n]), u = Ce((g) => {
    r && t?.(g);
  }, [r, t]);
  return P.createElement(
    "nav",
    { ...a },
    P.createElement(
      s.PreviousMonthButton,
      { type: "button", className: i[A.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: u },
      P.createElement(s.Chevron, { disabled: r ? void 0 : !0, className: i[A.Chevron], orientation: "left" })
    ),
    P.createElement(
      s.NextMonthButton,
      { type: "button", className: i[A.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": d(o), onClick: f },
      P.createElement(s.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: i[A.Chevron] })
    )
  );
}
function As(e) {
  const { components: t } = wt();
  return P.createElement(t.Button, { ...e });
}
function js(e) {
  return P.createElement("option", { ...e });
}
function zs(e) {
  const { components: t } = wt();
  return P.createElement(t.Button, { ...e });
}
function Hs(e) {
  const { rootRef: t, ...n } = e;
  return P.createElement("div", { ...n, ref: t });
}
function Ls(e) {
  return P.createElement("select", { ...e });
}
function Vs(e) {
  const { week: t, ...n } = e;
  return P.createElement("tr", { ...n });
}
function qs(e) {
  return P.createElement("th", { ...e });
}
function Gs(e) {
  return P.createElement(
    "thead",
    { "aria-hidden": !0 },
    P.createElement("tr", { ...e })
  );
}
function Us(e) {
  const { week: t, ...n } = e;
  return P.createElement("th", { ...n });
}
function Zs(e) {
  return P.createElement("th", { ...e });
}
function Qs(e) {
  return P.createElement("tbody", { ...e });
}
function Xs(e) {
  const { components: t } = wt();
  return P.createElement(t.Dropdown, { ...e });
}
const Js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Ss,
  CaptionLabel: Os,
  Chevron: Cs,
  Day: Ws,
  DayButton: _s,
  Dropdown: Ts,
  DropdownNav: Ps,
  Footer: Es,
  Month: Ys,
  MonthCaption: Fs,
  MonthGrid: $s,
  Months: Is,
  MonthsDropdown: Rs,
  Nav: Bs,
  NextMonthButton: As,
  Option: js,
  PreviousMonthButton: zs,
  Root: Hs,
  Select: Ls,
  Week: Vs,
  WeekNumber: Us,
  WeekNumberHeader: Zs,
  Weekday: qs,
  Weekdays: Gs,
  Weeks: Qs,
  YearsDropdown: Xs
}, Symbol.toStringTag, { value: "Module" }));
function je(e, t, n = !1, r = Re) {
  let { from: o, to: a } = e;
  const { differenceInCalendarDays: s, isSameDay: i } = r;
  return o && a ? (s(a, o) < 0 && ([o, a] = [a, o]), s(t, o) >= (n ? 1 : 0) && s(a, t) >= (n ? 1 : 0)) : !n && a ? i(a, t) : !n && o ? i(o, t) : !1;
}
function Kt(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Ct(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function en(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function tn(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function ir(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function lr(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function ze(e, t, n = Re) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: a, isAfter: s } = n;
  return r.some((i) => {
    if (typeof i == "boolean")
      return i;
    if (n.isDate(i))
      return o(e, i);
    if (lr(i, n))
      return i.some((l) => o(e, l));
    if (Ct(i))
      return je(i, e, !1, n);
    if (ir(i))
      return Array.isArray(i.dayOfWeek) ? i.dayOfWeek.includes(e.getDay()) : i.dayOfWeek === e.getDay();
    if (Kt(i)) {
      const l = a(i.before, e), d = a(i.after, e), f = l > 0, u = d < 0;
      return s(i.before, i.after) ? u && f : f || u;
    }
    return en(i) ? a(e, i.after) > 0 : tn(i) ? a(i.before, e) > 0 : typeof i == "function" ? i(e) : !1;
  });
}
function Ks(e, t, n, r, o) {
  const { disabled: a, hidden: s, modifiers: i, showOutsideDays: l, broadcastCalendar: d, today: f = o.today() } = t, { isSameDay: u, isSameMonth: g, startOfMonth: p, isBefore: h, endOfMonth: D, isAfter: N } = o, y = n && p(n), T = r && D(r), W = {
    [ie.focused]: [],
    [ie.outside]: [],
    [ie.disabled]: [],
    [ie.hidden]: [],
    [ie.today]: []
  }, k = {};
  for (const v of e) {
    const { date: w, displayMonth: $ } = v, L = !!($ && !g(w, $)), B = !!(y && h(w, y)), I = !!(T && N(w, T)), R = !!(a && ze(w, a, o)), X = !!(s && ze(w, s, o)) || B || I || // Broadcast calendar will show outside days as default
    !d && !l && L || d && l === !1 && L, V = u(w, f);
    L && W.outside.push(v), R && W.disabled.push(v), X && W.hidden.push(v), V && W.today.push(v), i && Object.keys(i).forEach((O) => {
      const _ = i?.[O];
      _ && ze(w, _, o) && (k[O] ? k[O].push(v) : k[O] = [v]);
    });
  }
  return (v) => {
    const w = {
      [ie.focused]: !1,
      [ie.disabled]: !1,
      [ie.hidden]: !1,
      [ie.outside]: !1,
      [ie.today]: !1
    }, $ = {};
    for (const L in W) {
      const B = W[L];
      w[L] = B.some((I) => I === v);
    }
    for (const L in k)
      $[L] = k[L].some((B) => B === v);
    return {
      ...w,
      // custom modifiers should override all the previous ones
      ...$
    };
  };
}
function ei(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [a]) => (n[a] ? o.push(n[a]) : t[ie[a]] ? o.push(t[ie[a]]) : t[Pe[a]] && o.push(t[Pe[a]]), o), [t[A.Day]]);
}
function ti(e) {
  return {
    ...Js,
    ...e
  };
}
function ni(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function ri() {
  const e = {};
  for (const t in A)
    e[A[t]] = `rdp-${A[t]}`;
  for (const t in ie)
    e[ie[t]] = `rdp-${ie[t]}`;
  for (const t in Pe)
    e[Pe[t]] = `rdp-${Pe[t]}`;
  for (const t in Me)
    e[Me[t]] = `rdp-${Me[t]}`;
  return e;
}
function cr(e, t, n) {
  return (n ?? new Ne(t)).formatMonthYear(e);
}
const oi = cr;
function ai(e, t, n) {
  return (n ?? new Ne(t)).format(e, "d");
}
function si(e, t = Re) {
  return t.format(e, "LLLL");
}
function ii(e, t, n) {
  return (n ?? new Ne(t)).format(e, "cccccc");
}
function li(e, t = Re) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function ci() {
  return "";
}
function dr(e, t = Re) {
  return t.format(e, "yyyy");
}
const di = dr, ui = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: cr,
  formatDay: ai,
  formatMonthCaption: oi,
  formatMonthDropdown: si,
  formatWeekNumber: li,
  formatWeekNumberHeader: ci,
  formatWeekdayName: ii,
  formatYearCaption: di,
  formatYearDropdown: dr
}, Symbol.toStringTag, { value: "Module" }));
function fi(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...ui,
    ...e
  };
}
function nn(e, t, n, r) {
  let o = (r ?? new Ne(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const mi = nn;
function rn(e, t, n) {
  return (n ?? new Ne(t)).formatMonthYear(e);
}
const hi = rn;
function ur(e, t, n, r) {
  let o = (r ?? new Ne(n)).format(e, "PPPP");
  return t?.today && (o = `Today, ${o}`), o;
}
function fr(e) {
  return "Choose the Month";
}
function mr() {
  return "";
}
const pi = "Go to the Next Month";
function hr(e, t) {
  return pi;
}
function pr(e) {
  return "Go to the Previous Month";
}
function gr(e, t, n) {
  return (n ?? new Ne(t)).format(e, "cccc");
}
function br(e, t) {
  return `Week ${e}`;
}
function wr(e) {
  return "Week Number";
}
function yr(e) {
  return "Choose the Year";
}
const gi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: hi,
  labelDay: mi,
  labelDayButton: nn,
  labelGrid: rn,
  labelGridcell: ur,
  labelMonthDropdown: fr,
  labelNav: mr,
  labelNext: hr,
  labelPrevious: pr,
  labelWeekNumber: br,
  labelWeekNumberHeader: wr,
  labelWeekday: gr,
  labelYearDropdown: yr
}, Symbol.toStringTag, { value: "Module" })), _e = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function bi(e, t) {
  const n = t.locale?.labels ?? {};
  return {
    ...gi,
    ...e ?? {},
    labelDayButton: _e(nn, e?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: _e(fr, e?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: _e(hr, e?.labelNext, n.labelNext),
    labelPrevious: _e(pr, e?.labelPrevious, n.labelPrevious),
    labelWeekNumber: _e(br, e?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: _e(yr, e?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: _e(rn, e?.labelGrid, n.labelGrid),
    labelGridcell: _e(ur, e?.labelGridcell, n.labelGridcell),
    labelNav: _e(mr, e?.labelNav, n.labelNav),
    labelWeekNumberHeader: _e(wr, e?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: _e(gr, e?.labelWeekday, n.labelWeekday)
  };
}
function wi(e, t, n, r, o) {
  const { startOfMonth: a, startOfYear: s, endOfYear: i, eachMonthOfInterval: l, getMonth: d } = o;
  return l({
    start: s(e),
    end: i(e)
  }).map((g) => {
    const p = r.formatMonthDropdown(g, o), h = d(g), D = t && g < a(t) || n && g > a(n) || !1;
    return { value: h, label: p, disabled: D };
  });
}
function yi(e, t = {}, n = {}) {
  let r = { ...t?.[A.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n?.[o]
    };
  }), r;
}
function vi(e, t, n, r) {
  const o = r ?? e.today(), a = n ? e.startOfBroadcastWeek(o, e) : t ? e.startOfISOWeek(o) : e.startOfWeek(o), s = [];
  for (let i = 0; i < 7; i++) {
    const l = e.addDays(a, i);
    s.push(l);
  }
  return s;
}
function xi(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: a, endOfYear: s, eachYearOfInterval: i, getYear: l } = r, d = a(e), f = s(t), u = i({ start: d, end: f });
  return o && u.reverse(), u.map((g) => {
    const p = n.formatYearDropdown(g, r);
    return {
      value: l(g),
      label: p,
      disabled: !1
    };
  });
}
function ki(e, t = {}) {
  const { weekStartsOn: n, locale: r } = t, o = n ?? r?.options?.weekStartsOn ?? 0, a = (i) => {
    const l = typeof i == "number" || typeof i == "string" ? new Date(i) : i;
    return new me(l.getFullYear(), l.getMonth(), l.getDate(), 12, 0, 0, e);
  }, s = (i) => {
    const l = a(i);
    return new Date(l.getFullYear(), l.getMonth(), l.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => a(me.tz(e)),
    newDate: (i, l, d) => new me(i, l, d, 12, 0, 0, e),
    startOfDay: (i) => a(i),
    startOfWeek: (i, l) => {
      const d = a(i), f = l?.weekStartsOn ?? o, u = (d.getDay() - f + 7) % 7;
      return d.setDate(d.getDate() - u), d;
    },
    startOfISOWeek: (i) => {
      const l = a(i), d = (l.getDay() - 1 + 7) % 7;
      return l.setDate(l.getDate() - d), l;
    },
    startOfMonth: (i) => {
      const l = a(i);
      return l.setDate(1), l;
    },
    startOfYear: (i) => {
      const l = a(i);
      return l.setMonth(0, 1), l;
    },
    endOfWeek: (i, l) => {
      const d = a(i), g = (((l?.weekStartsOn ?? o) + 6) % 7 - d.getDay() + 7) % 7;
      return d.setDate(d.getDate() + g), d;
    },
    endOfISOWeek: (i) => {
      const l = a(i), d = (7 - l.getDay()) % 7;
      return l.setDate(l.getDate() + d), l;
    },
    endOfMonth: (i) => {
      const l = a(i);
      return l.setMonth(l.getMonth() + 1, 0), l;
    },
    endOfYear: (i) => {
      const l = a(i);
      return l.setMonth(11, 31), l;
    },
    eachMonthOfInterval: (i) => {
      const l = a(i.start), d = a(i.end), f = [], u = new me(l.getFullYear(), l.getMonth(), 1, 12, 0, 0, e), g = d.getFullYear() * 12 + d.getMonth();
      for (; u.getFullYear() * 12 + u.getMonth() <= g; )
        f.push(new me(u, e)), u.setMonth(u.getMonth() + 1, 1);
      return f;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (i, l) => {
      const d = a(i);
      return d.setDate(d.getDate() + l), d;
    },
    addWeeks: (i, l) => {
      const d = a(i);
      return d.setDate(d.getDate() + l * 7), d;
    },
    addMonths: (i, l) => {
      const d = a(i);
      return d.setMonth(d.getMonth() + l), d;
    },
    addYears: (i, l) => {
      const d = a(i);
      return d.setFullYear(d.getFullYear() + l), d;
    },
    eachYearOfInterval: (i) => {
      const l = a(i.start), d = a(i.end), f = [], u = new me(l.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; u.getFullYear() <= d.getFullYear(); )
        f.push(new me(u, e)), u.setFullYear(u.getFullYear() + 1, 0, 1);
      return f;
    },
    getWeek: (i, l) => {
      const d = s(i);
      return Jt(d, {
        weekStartsOn: l?.weekStartsOn ?? o,
        firstWeekContainsDate: l?.firstWeekContainsDate ?? r?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (i) => {
      const l = s(i);
      return Xt(l);
    },
    differenceInCalendarDays: (i, l) => {
      const d = s(i), f = s(l);
      return Qt(d, f);
    },
    differenceInCalendarMonths: (i, l) => {
      const d = s(i), f = s(l);
      return Xn(d, f);
    }
  };
}
const yt = (e) => e instanceof HTMLElement ? e : null, At = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], Mi = (e) => yt(e.querySelector("[data-animated-month]")), jt = (e) => yt(e.querySelector("[data-animated-caption]")), zt = (e) => yt(e.querySelector("[data-animated-weeks]")), Di = (e) => yt(e.querySelector("[data-animated-nav]")), Ni = (e) => yt(e.querySelector("[data-animated-weekdays]"));
function Si(e, t, { classNames: n, months: r, focused: o, dateLib: a }) {
  const s = Ke(null), i = Ke(r), l = Ke(!1);
  qr(() => {
    const d = i.current;
    if (i.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || d.length === 0 || r.length !== d.length)
      return;
    const f = a.isSameMonth(r[0].date, d[0].date), u = a.isAfter(r[0].date, d[0].date), g = u ? n[Me.caption_after_enter] : n[Me.caption_before_enter], p = u ? n[Me.weeks_after_enter] : n[Me.weeks_before_enter], h = s.current, D = e.current.cloneNode(!0);
    if (D instanceof HTMLElement ? (At(D).forEach((W) => {
      if (!(W instanceof HTMLElement))
        return;
      const k = Mi(W);
      k && W.contains(k) && W.removeChild(k);
      const v = jt(W);
      v && v.classList.remove(g);
      const w = zt(W);
      w && w.classList.remove(p);
    }), s.current = D) : s.current = null, l.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const N = h instanceof HTMLElement ? At(h) : [], y = At(e.current);
    if (y?.every((T) => T instanceof HTMLElement) && N && N.every((T) => T instanceof HTMLElement)) {
      l.current = !0, e.current.style.isolation = "isolate";
      const T = Di(e.current);
      T && (T.style.zIndex = "1"), y.forEach((W, k) => {
        const v = N[k];
        if (!v)
          return;
        W.style.position = "relative", W.style.overflow = "hidden";
        const w = jt(W);
        w && w.classList.add(g);
        const $ = zt(W);
        $ && $.classList.add(p);
        const L = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), T && (T.style.zIndex = ""), w && w.classList.remove(g), $ && $.classList.remove(p), W.style.position = "", W.style.overflow = "", W.contains(v) && W.removeChild(v);
        };
        v.style.pointerEvents = "none", v.style.position = "absolute", v.style.overflow = "hidden", v.setAttribute("aria-hidden", "true");
        const B = Ni(v);
        B && (B.style.opacity = "0");
        const I = jt(v);
        I && (I.classList.add(u ? n[Me.caption_before_exit] : n[Me.caption_after_exit]), I.addEventListener("animationend", L));
        const R = zt(v);
        R && R.classList.add(u ? n[Me.weeks_before_exit] : n[Me.weeks_after_exit]), W.insertBefore(v, W.firstChild);
      });
    }
  });
}
function Oi(e, t, n, r) {
  const o = e[0], a = e[e.length - 1], { ISOWeek: s, fixedWeeks: i, broadcastCalendar: l } = n ?? {}, { addDays: d, differenceInCalendarDays: f, differenceInCalendarMonths: u, endOfBroadcastWeek: g, endOfISOWeek: p, endOfMonth: h, endOfWeek: D, isAfter: N, startOfBroadcastWeek: y, startOfISOWeek: T, startOfWeek: W } = r, k = l ? y(o, r) : s ? T(o) : W(o), v = l ? g(a) : s ? p(h(a)) : D(h(a)), w = t && (l ? g(t) : s ? p(t) : D(t)), $ = w && N(v, w) ? w : v, L = f($, k), B = u(a, o) + 1, I = [];
  for (let V = 0; V <= L; V++) {
    const O = d(k, V);
    I.push(O);
  }
  const X = (l ? 35 : 42) * B;
  if (i && I.length < X) {
    const V = X - I.length;
    for (let O = 0; O < V; O++) {
      const _ = d(I[I.length - 1], 1);
      I.push(_);
    }
  }
  return I;
}
function Ci(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((a, s) => a.concat(s.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function Wi(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, a = [];
  for (let s = 0; s < o; s++) {
    const i = r.addMonths(e, s);
    if (t && i > t)
      break;
    a.push(i);
  }
  return a;
}
function Dn(e, t, n, r) {
  const { month: o, defaultMonth: a, today: s = r.today(), numberOfMonths: i = 1 } = e;
  let l = o || a || s;
  const { differenceInCalendarMonths: d, addMonths: f, startOfMonth: u } = r;
  if (n && d(n, l) < i - 1) {
    const g = -1 * (i - 1);
    l = f(n, g);
  }
  return t && d(l, t) < 0 && (l = t), u(l);
}
function _i(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: a, endOfISOWeek: s, endOfMonth: i, endOfWeek: l, getISOWeek: d, getWeek: f, startOfBroadcastWeek: u, startOfISOWeek: g, startOfWeek: p } = r, h = e.reduce((D, N) => {
    const y = n.broadcastCalendar ? u(N, r) : n.ISOWeek ? g(N) : p(N), T = n.broadcastCalendar ? a(N) : n.ISOWeek ? s(i(N)) : l(i(N)), W = t.filter(($) => $ >= y && $ <= T), k = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && W.length < k) {
      const $ = t.filter((L) => {
        const B = k - W.length;
        return L > T && L <= o(T, B);
      });
      W.push(...$);
    }
    const v = W.reduce(($, L) => {
      const B = n.ISOWeek ? d(L) : f(L), I = $.find((X) => X.weekNumber === B), R = new ar(L, N, r);
      return I ? I.days.push(R) : $.push(new Ns(B, [R])), $;
    }, []), w = new Ds(N, v);
    return D.push(w), D;
  }, []);
  return n.reverseMonths ? h.reverse() : h;
}
function Ti(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: a, startOfMonth: s, endOfMonth: i, addYears: l, endOfYear: d, newDate: f, today: u } = t, { fromYear: g, toYear: p, fromMonth: h, toMonth: D } = e;
  !n && h && (n = h), !n && g && (n = t.newDate(g, 0, 1)), !r && D && (r = D), !r && p && (r = f(p, 11, 31));
  const N = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = s(n) : g ? n = f(g, 0, 1) : !n && N && (n = o(l(e.today ?? u(), -100))), r ? r = i(r) : p ? r = f(p, 11, 31) : !r && N && (r = d(e.today ?? u())), [
    n && a(n),
    r && a(r)
  ];
}
function Pi(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a = 1 } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: l } = r, d = o ? a : 1, f = s(e);
  if (!t)
    return i(f, d);
  if (!(l(t, e) < a))
    return i(f, d);
}
function Ei(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: l } = r, d = o ? a ?? 1 : 1, f = s(e);
  if (!t)
    return i(f, -d);
  if (!(l(f, t) <= 0))
    return i(f, -d);
}
function Yi(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function Wt(e, t) {
  const [n, r] = Dt(e);
  return [t === void 0 ? n : t, r];
}
function Fi(e, t) {
  const [n, r] = Ti(e, t), { startOfMonth: o, endOfMonth: a } = t, s = Dn(e, n, r, t), [i, l] = Wt(
    s,
    // initialMonth is always computed from props.month if provided
    e.month ? s : void 0
  );
  Fn(() => {
    const k = Dn(e, n, r, t);
    l(k);
  }, [e.timeZone]);
  const { months: d, weeks: f, days: u, previousMonth: g, nextMonth: p } = et(() => {
    const k = Wi(i, r, { numberOfMonths: e.numberOfMonths }, t), v = Oi(k, e.endMonth ? a(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), w = _i(k, v, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), $ = Yi(w), L = Ci(w), B = Ei(i, n, e, t), I = Pi(i, r, e, t);
    return {
      months: w,
      weeks: $,
      days: L,
      previousMonth: B,
      nextMonth: I
    };
  }, [
    t,
    i.getTime(),
    r?.getTime(),
    n?.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    e.endMonth?.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: h, onMonthChange: D } = e, N = (k) => f.some((v) => v.days.some((w) => w.isEqualTo(k))), y = (k) => {
    if (h)
      return;
    let v = o(k);
    n && v < o(n) && (v = o(n)), r && v > o(r) && (v = o(r)), l(v), D?.(v);
  };
  return {
    months: d,
    weeks: f,
    days: u,
    navStart: n,
    navEnd: r,
    previousMonth: g,
    nextMonth: p,
    goToMonth: y,
    goToDay: (k) => {
      N(k) || y(k.date);
    }
  };
}
var Fe;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Fe || (Fe = {}));
function Nn(e) {
  return !e[ie.disabled] && !e[ie.hidden] && !e[ie.outside];
}
function $i(e, t, n, r) {
  let o, a = -1;
  for (const s of e) {
    const i = t(s);
    Nn(i) && (i[ie.focused] && a < Fe.FocusedModifier ? (o = s, a = Fe.FocusedModifier) : r?.isEqualTo(s) && a < Fe.LastFocused ? (o = s, a = Fe.LastFocused) : n(s.date) && a < Fe.Selected ? (o = s, a = Fe.Selected) : i[ie.today] && a < Fe.Today && (o = s, a = Fe.Today));
  }
  return o || (o = e.find((s) => Nn(t(s)))), o;
}
function Ii(e, t, n, r, o, a, s) {
  const { ISOWeek: i, broadcastCalendar: l } = a, { addDays: d, addMonths: f, addWeeks: u, addYears: g, endOfBroadcastWeek: p, endOfISOWeek: h, endOfWeek: D, max: N, min: y, startOfBroadcastWeek: T, startOfISOWeek: W, startOfWeek: k } = s;
  let w = {
    day: d,
    week: u,
    month: f,
    year: g,
    startOfWeek: ($) => l ? T($, s) : i ? W($) : k($),
    endOfWeek: ($) => l ? p($) : i ? h($) : D($)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? w = N([r, w]) : t === "after" && o && (w = y([o, w])), w;
}
function vr(e, t, n, r, o, a, s, i = 0) {
  if (i > 365)
    return;
  const l = Ii(e, t, n.date, r, o, a, s), d = !!(a.disabled && ze(l, a.disabled, s)), f = !!(a.hidden && ze(l, a.hidden, s)), u = l, g = new ar(l, u, s);
  return !d && !f ? g : vr(e, t, g, r, o, a, s, i + 1);
}
function Ri(e, t, n, r, o) {
  const { autoFocus: a } = e, [s, i] = Dt(), l = $i(t.days, n, r || (() => !1), s), [d, f] = Dt(a ? l : void 0);
  return {
    isFocusTarget: (D) => !!l?.isEqualTo(D),
    setFocused: f,
    focused: d,
    blur: () => {
      i(d), f(void 0);
    },
    moveFocus: (D, N) => {
      if (!d)
        return;
      const y = vr(D, N, d, t.navStart, t.navEnd, e, o);
      y && (e.disableNavigation && !t.days.some((W) => W.isEqualTo(y)) || (t.goToDay(y), f(y)));
    }
  };
}
function Bi(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, s] = Wt(n, o ? n : void 0), i = o ? n : a, { isSameDay: l } = t, d = (p) => i?.some((h) => l(h, p)) ?? !1, { min: f, max: u } = e;
  return {
    selected: i,
    select: (p, h, D) => {
      let N = [...i ?? []];
      if (d(p)) {
        if (i?.length === f || r && i?.length === 1)
          return;
        N = i?.filter((y) => !l(y, p));
      } else
        i?.length === u ? N = [p] : N = [...N, p];
      return o || s(N), o?.(N, p, h, D), N;
    },
    isSelected: d
  };
}
function Ai(e, t, n = 0, r = 0, o = !1, a = Re) {
  const { from: s, to: i } = t || {}, { isSameDay: l, isAfter: d, isBefore: f } = a;
  let u;
  if (!s && !i)
    u = { from: e, to: n > 0 ? void 0 : e };
  else if (s && !i)
    l(s, e) ? n === 0 ? u = { from: s, to: e } : o ? u = { from: s, to: void 0 } : u = void 0 : f(e, s) ? u = { from: e, to: s } : u = { from: s, to: e };
  else if (s && i)
    if (l(s, e) && l(i, e))
      o ? u = { from: s, to: i } : u = void 0;
    else if (l(s, e))
      u = { from: s, to: n > 0 ? void 0 : e };
    else if (l(i, e))
      u = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, s))
      u = { from: e, to: i };
    else if (d(e, s))
      u = { from: s, to: e };
    else if (d(e, i))
      u = { from: s, to: e };
    else
      throw new Error("Invalid range");
  if (u?.from && u?.to) {
    const g = a.differenceInCalendarDays(u.to, u.from);
    r > 0 && g > r ? u = { from: e, to: void 0 } : n > 1 && g < n && (u = { from: e, to: void 0 });
  }
  return u;
}
function ji(e, t, n = Re) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), s = Math.min(a, 6);
  for (let i = 0; i <= s; i++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Sn(e, t, n = Re) {
  return je(e, t.from, !1, n) || je(e, t.to, !1, n) || je(t, e.from, !1, n) || je(t, e.to, !1, n);
}
function zi(e, t, n = Re) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((i) => typeof i != "function").some((i) => typeof i == "boolean" ? i : n.isDate(i) ? je(e, i, !1, n) : lr(i, n) ? i.some((l) => je(e, l, !1, n)) : Ct(i) ? i.from && i.to ? Sn(e, { from: i.from, to: i.to }, n) : !1 : ir(i) ? ji(e, i.dayOfWeek, n) : Kt(i) ? n.isAfter(i.before, i.after) ? Sn(e, {
    from: n.addDays(i.after, 1),
    to: n.addDays(i.before, -1)
  }, n) : ze(e.from, i, n) || ze(e.to, i, n) : en(i) || tn(i) ? ze(e.from, i, n) || ze(e.to, i, n) : !1))
    return !0;
  const s = r.filter((i) => typeof i == "function");
  if (s.length) {
    let i = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let d = 0; d <= l; d++) {
      if (s.some((f) => f(i)))
        return !0;
      i = n.addDays(i, 1);
    }
  }
  return !1;
}
function Hi(e, t) {
  const { disabled: n, excludeDisabled: r, resetOnSelect: o, selected: a, required: s, onSelect: i } = e, [l, d] = Wt(a, i ? a : void 0), f = i ? a : l;
  return {
    selected: f,
    select: (p, h, D) => {
      const { min: N, max: y } = e;
      let T;
      if (p) {
        const W = f?.from, k = f?.to, v = !!W && !!k, w = !!W && !!k && t.isSameDay(W, k) && t.isSameDay(p, W);
        o && (v || !f?.from) ? !s && w ? T = void 0 : T = { from: p, to: void 0 } : T = Ai(p, f, N, y, s, t);
      }
      return r && n && T?.from && T.to && zi({ from: T.from, to: T.to }, n, t) && (T.from = p, T.to = void 0), i || d(T), i?.(T, p, h, D), T;
    },
    isSelected: (p) => f && je(f, p, !1, t)
  };
}
function Li(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, s] = Wt(n, o ? n : void 0), i = o ? n : a, { isSameDay: l } = t;
  return {
    selected: i,
    select: (u, g, p) => {
      let h = u;
      return !r && i && i && l(u, i) && (h = void 0), o || s(h), o?.(h, u, g, p), h;
    },
    isSelected: (u) => i ? l(i, u) : !1
  };
}
function Vi(e, t) {
  const n = Li(e, t), r = Bi(e, t), o = Hi(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function We(e, t) {
  return e instanceof me && e.timeZone === t ? e : new me(e, t);
}
function Qe(e, t, n) {
  return We(e, t);
}
function On(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? Qe(e, t) : Array.isArray(e) ? e.map((r) => r instanceof Date ? Qe(r, t) : r) : Ct(e) ? {
    ...e,
    from: e.from ? We(e.from, t) : e.from,
    to: e.to ? We(e.to, t) : e.to
  } : Kt(e) ? {
    before: Qe(e.before, t),
    after: Qe(e.after, t)
  } : en(e) ? {
    after: Qe(e.after, t)
  } : tn(e) ? {
    before: Qe(e.before, t)
  } : e;
}
function Ht(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => On(r, t)) : On(e, t));
}
function qi(e) {
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = We(t.today, n)), t.month && (t.month = We(t.month, n)), t.defaultMonth && (t.defaultMonth = We(t.defaultMonth, n)), t.startMonth && (t.startMonth = We(t.startMonth, n)), t.endMonth && (t.endMonth = We(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = We(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((G) => We(G, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? We(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? We(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = Ht(t.disabled, n)), t.hidden !== void 0 && (t.hidden = Ht(t.hidden, n)), t.modifiers)) {
    const G = {};
    Object.keys(t.modifiers).forEach((ne) => {
      G[ne] = Ht(t.modifiers?.[ne], n);
    }), t.modifiers = G;
  }
  const { components: r, formatters: o, labels: a, dateLib: s, locale: i, classNames: l } = et(() => {
    const G = { ...or, ...t.locale }, ne = t.broadcastCalendar ? 1 : t.weekStartsOn, H = t.noonSafe && t.timeZone ? ki(t.timeZone, {
      weekStartsOn: ne,
      locale: G
    }) : void 0, te = t.dateLib && H ? { ...H, ...t.dateLib } : t.dateLib ?? H, ke = new Ne({
      locale: G,
      weekStartsOn: ne,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, te);
    return {
      dateLib: ke,
      components: ti(t.components),
      formatters: fi(t.formatters),
      labels: bi(t.labels, ke.options),
      locale: G,
      classNames: { ...ri(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: s.today() });
  const { captionLayout: d, mode: f, navLayout: u, numberOfMonths: g = 1, onDayBlur: p, onDayClick: h, onDayFocus: D, onDayKeyDown: N, onDayMouseEnter: y, onDayMouseLeave: T, onNextClick: W, onPrevClick: k, showWeekNumber: v, styles: w } = t, { formatCaption: $, formatDay: L, formatMonthDropdown: B, formatWeekNumber: I, formatWeekNumberHeader: R, formatWeekdayName: X, formatYearDropdown: V } = o, O = Fi(t, s), { days: _, months: M, navStart: S, navEnd: x, previousMonth: C, nextMonth: F, goToMonth: j } = O, Z = Ks(_, t, S, x, s), { isSelected: Q, select: K, selected: ee } = Vi(t, s) ?? {}, { blur: le, focused: ue, isFocusTarget: he, moveFocus: E, setFocused: U } = Ri(t, O, Z, Q ?? (() => !1), s), { labelDayButton: se, labelGridcell: be, labelGrid: Se, labelMonthDropdown: z, labelNav: q, labelPrevious: fe, labelNext: we, labelWeekday: ye, labelWeekNumber: ae, labelWeekNumberHeader: pe, labelYearDropdown: Ue } = a, ve = et(() => vi(s, t.ISOWeek, t.broadcastCalendar, t.today), [s, t.ISOWeek, t.broadcastCalendar, t.today]), Ee = f !== void 0 || h !== void 0, xe = Ce(() => {
    C && (j(C), k?.(C));
  }, [C, j, k]), Oe = Ce(() => {
    F && (j(F), W?.(F));
  }, [j, F, W]), Ye = Ce((G, ne) => (H) => {
    H.preventDefault(), H.stopPropagation(), U(G), !ne.disabled && (K?.(G.date, ne, H), h?.(G.date, ne, H));
  }, [K, h, U]), Be = Ce((G, ne) => (H) => {
    U(G), D?.(G.date, ne, H);
  }, [D, U]), vt = Ce((G, ne) => (H) => {
    le(), p?.(G.date, ne, H);
  }, [le, p]), xt = Ce((G, ne) => (H) => {
    const te = {
      ArrowLeft: [
        H.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        H.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [H.shiftKey ? "year" : "week", "after"],
      ArrowUp: [H.shiftKey ? "year" : "week", "before"],
      PageUp: [H.shiftKey ? "year" : "month", "before"],
      PageDown: [H.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (te[H.key]) {
      H.preventDefault(), H.stopPropagation();
      const [ke, J] = te[H.key];
      E(ke, J);
    }
    N?.(G.date, ne, H);
  }, [E, N, t.dir]), Tt = Ce((G, ne) => (H) => {
    y?.(G.date, ne, H);
  }, [y]), Pt = Ce((G, ne) => (H) => {
    T?.(G.date, ne, H);
  }, [T]), Et = Ce((G) => (ne) => {
    const H = Number(ne.target.value), te = s.setMonth(s.startOfMonth(G), H);
    j(te);
  }, [s, j]), Ae = Ce((G) => (ne) => {
    const H = Number(ne.target.value), te = s.setYear(s.startOfMonth(G), H);
    j(te);
  }, [s, j]), { className: at, style: Yt } = et(() => ({
    className: [l[A.Root], t.className].filter(Boolean).join(" "),
    style: { ...w?.[A.Root], ...t.style }
  }), [l, t.className, t.style, w]), Br = ni(t), cn = Ke(null);
  Si(cn, !!t.animate, {
    classNames: l,
    months: M,
    focused: ue,
    dateLib: s
  });
  const Ar = {
    dayPickerProps: t,
    selected: ee,
    select: K,
    isSelected: Q,
    months: M,
    nextMonth: F,
    previousMonth: C,
    goToMonth: j,
    getModifiers: Z,
    components: r,
    classNames: l,
    styles: w,
    labels: a,
    formatters: o
  };
  return P.createElement(
    sr.Provider,
    { value: Ar },
    P.createElement(
      r.Root,
      { rootRef: t.animate ? cn : void 0, className: at, style: Yt, dir: t.dir, id: t.id, lang: t.lang ?? i.code, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...Br },
      P.createElement(
        r.Months,
        { className: l[A.Months], style: w?.[A.Months] },
        !t.hideNavigation && !u && P.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[A.Nav], style: w?.[A.Nav], "aria-label": q(), onPreviousClick: xe, onNextClick: Oe, previousMonth: C, nextMonth: F }),
        M.map((G, ne) => P.createElement(
          r.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: l[A.Month],
            style: w?.[A.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: ne,
            displayIndex: ne,
            calendarMonth: G
          },
          u === "around" && !t.hideNavigation && ne === 0 && P.createElement(
            r.PreviousMonthButton,
            { type: "button", className: l[A.PreviousMonthButton], tabIndex: C ? void 0 : -1, "aria-disabled": C ? void 0 : !0, "aria-label": fe(C), onClick: xe, "data-animated-button": t.animate ? "true" : void 0 },
            P.createElement(r.Chevron, { disabled: C ? void 0 : !0, className: l[A.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          P.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: l[A.MonthCaption], style: w?.[A.MonthCaption], calendarMonth: G, displayIndex: ne }, d?.startsWith("dropdown") ? P.createElement(
            r.DropdownNav,
            { className: l[A.Dropdowns], style: w?.[A.Dropdowns] },
            (() => {
              const H = d === "dropdown" || d === "dropdown-months" ? P.createElement(r.MonthsDropdown, { key: "month", className: l[A.MonthsDropdown], "aria-label": z(), classNames: l, components: r, disabled: !!t.disableNavigation, onChange: Et(G.date), options: wi(G.date, S, x, o, s), style: w?.[A.Dropdown], value: s.getMonth(G.date) }) : P.createElement("span", { key: "month" }, B(G.date, s)), te = d === "dropdown" || d === "dropdown-years" ? P.createElement(r.YearsDropdown, { key: "year", className: l[A.YearsDropdown], "aria-label": Ue(s.options), classNames: l, components: r, disabled: !!t.disableNavigation, onChange: Ae(G.date), options: xi(S, x, o, s, !!t.reverseYears), style: w?.[A.Dropdown], value: s.getYear(G.date) }) : P.createElement("span", { key: "year" }, V(G.date, s));
              return s.getMonthYearOrder() === "year-first" ? [te, H] : [H, te];
            })(),
            P.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, $(G.date, s.options, s))
          ) : P.createElement(r.CaptionLabel, { className: l[A.CaptionLabel], role: "status", "aria-live": "polite" }, $(G.date, s.options, s))),
          u === "around" && !t.hideNavigation && ne === g - 1 && P.createElement(
            r.NextMonthButton,
            { type: "button", className: l[A.NextMonthButton], tabIndex: F ? void 0 : -1, "aria-disabled": F ? void 0 : !0, "aria-label": we(F), onClick: Oe, "data-animated-button": t.animate ? "true" : void 0 },
            P.createElement(r.Chevron, { disabled: F ? void 0 : !0, className: l[A.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          ne === g - 1 && u === "after" && !t.hideNavigation && P.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[A.Nav], style: w?.[A.Nav], "aria-label": q(), onPreviousClick: xe, onNextClick: Oe, previousMonth: C, nextMonth: F }),
          P.createElement(
            r.MonthGrid,
            { role: "grid", "aria-multiselectable": f === "multiple" || f === "range", "aria-label": Se(G.date, s.options, s) || void 0, className: l[A.MonthGrid], style: w?.[A.MonthGrid] },
            !t.hideWeekdays && P.createElement(
              r.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: l[A.Weekdays], style: w?.[A.Weekdays] },
              v && P.createElement(r.WeekNumberHeader, { "aria-label": pe(s.options), className: l[A.WeekNumberHeader], style: w?.[A.WeekNumberHeader], scope: "col" }, R()),
              ve.map((H) => P.createElement(r.Weekday, { "aria-label": ye(H, s.options, s), className: l[A.Weekday], key: String(H), style: w?.[A.Weekday], scope: "col" }, X(H, s.options, s)))
            ),
            P.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: l[A.Weeks], style: w?.[A.Weeks] }, G.weeks.map((H) => P.createElement(
              r.Week,
              { className: l[A.Week], key: H.weekNumber, style: w?.[A.Week], week: H },
              v && P.createElement(r.WeekNumber, { week: H, style: w?.[A.WeekNumber], "aria-label": ae(H.weekNumber, {
                locale: i
              }), className: l[A.WeekNumber], scope: "row", role: "rowheader" }, I(H.weekNumber, s)),
              H.days.map((te) => {
                const { date: ke } = te, J = Z(te);
                if (J[ie.focused] = !J.hidden && !!ue?.isEqualTo(te), J[Pe.selected] = Q?.(ke) || J.selected, Ct(ee)) {
                  const { from: Ft, to: $t } = ee;
                  J[Pe.range_start] = !!(Ft && $t && s.isSameDay(ke, Ft)), J[Pe.range_end] = !!(Ft && $t && s.isSameDay(ke, $t)), J[Pe.range_middle] = je(ee, ke, !0, s);
                }
                const jr = yi(J, w, t.modifiersStyles), zr = ei(J, l, t.modifiersClassNames), Hr = !Ee && !J.hidden ? be(ke, J, s.options, s) : void 0;
                return P.createElement(r.Day, { key: `${te.isoDate}_${te.displayMonthId}`, day: te, modifiers: J, className: zr.join(" "), style: jr, role: "gridcell", "aria-selected": J.selected || void 0, "aria-label": Hr, "data-day": te.isoDate, "data-month": te.outside ? te.dateMonthId : void 0, "data-selected": J.selected || void 0, "data-disabled": J.disabled || void 0, "data-hidden": J.hidden || void 0, "data-outside": te.outside || void 0, "data-focused": J.focused || void 0, "data-today": J.today || void 0 }, !J.hidden && Ee ? P.createElement(r.DayButton, { className: l[A.DayButton], style: w?.[A.DayButton], type: "button", day: te, modifiers: J, disabled: !J.focused && J.disabled || void 0, "aria-disabled": J.focused && J.disabled || void 0, tabIndex: he(te) ? 0 : -1, "aria-label": se(ke, J, s.options, s), onClick: Ye(te, J), onBlur: vt(te, J), onFocus: Be(te, J), onKeyDown: xt(te, J), onMouseEnter: Tt(te, J), onMouseLeave: Pt(te, J) }, L(ke, s.options, s)) : !J.hidden && L(te.date, s.options, s));
              })
            )))
          )
        ))
      ),
      t.footer && P.createElement(r.Footer, { className: l[A.Footer], style: w?.[A.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const Gi = ce(
  "flex w-full items-center justify-between rounded-lg text-sm transition-colors placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate",
  {
    variants: {
      variant: {
        default: "border border-input bg-background",
        flat: "bg-[var(--ui-surface-dark)] border border-[var(--ui-surface-dark-border)]",
        bordered: "border-2 border-default-200 bg-transparent",
        faded: "border border-default-200 bg-default-100",
        glass: "bg-[rgba(140,140,140,0.15)] border border-[rgba(140,140,140,0.15)]"
      },
      size: {
        sm: "h-8 px-2 text-xs",
        md: "h-10 px-3",
        lg: "h-12 px-4 text-base"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "md"
    }
  }
), on = m.forwardRef(
  ({
    value: e,
    onValueChange: t,
    placeholder: n,
    disabled: r,
    loading: o,
    className: a,
    triggerClassName: s,
    contentClassName: i,
    children: l,
    renderValue: d,
    startContent: f,
    variant: u,
    size: g,
    label: p,
    isRequired: h,
    labelPlacement: D = "outside",
    isInvalid: N,
    errorMessage: y,
    viewportClassName: T,
    showScrollButtons: W = !0,
    showViewportScrollbar: k = !1,
    style: v
  }, w) => {
    const $ = D === "inside";
    return /* @__PURE__ */ Y("div", { className: "flex flex-col gap-1.5", children: [
      p && !$ && /* @__PURE__ */ Y("label", { className: "block text-[12px] font-medium text-[var(--ui-color-label-muted)]", children: [
        p,
        h && /* @__PURE__ */ c("span", { className: "ml-0.5 text-danger", children: "*" })
      ] }),
      /* @__PURE__ */ Y(Te.Root, { value: e, onValueChange: t, disabled: r || o, children: [
        /* @__PURE__ */ Y(
          Te.Trigger,
          {
            ref: w,
            style: v,
            className: b(
              Gi({ variant: u, size: g }),
              $ && p && "items-start",
              N && "border-danger focus:ring-danger",
              "data-[state=open]:rounded-b-none",
              s,
              a
            ),
            children: [
              /* @__PURE__ */ Y(
                "span",
                {
                  className: b("flex gap-2 truncate min-w-0", $ && p ? "flex-col items-start gap-0" : "items-center"),
                  children: [
                    $ && p && /* @__PURE__ */ Y("span", { className: "text-[12px] text-[var(--ui-color-label-muted)]", children: [
                      p,
                      h && /* @__PURE__ */ c("span", { className: "ml-0.5 text-danger", children: "*" })
                    ] }),
                    /* @__PURE__ */ Y("span", { className: "flex items-center gap-2 min-w-0", children: [
                      f,
                      e ? d ? /* @__PURE__ */ c("span", { className: "truncate", children: d(e) }) : /* @__PURE__ */ c("span", { className: "truncate", children: e }) : /* @__PURE__ */ c(Te.Value, { placeholder: n })
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ c(Te.Icon, { asChild: !0, children: /* @__PURE__ */ c(
                "svg",
                {
                  className: "h-4 w-4 shrink-0 opacity-50 self-center",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" })
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ c(Te.Portal, { children: /* @__PURE__ */ Y(
          Te.Content,
          {
            "data-ui-select-scrollbar": k ? "true" : void 0,
            className: b(
              "relative z-[500] max-h-96 w-[var(--radix-select-trigger-width)] min-w-[var(--radix-select-trigger-width)] overflow-hidden rounded-t-none rounded-b-lg bg-[var(--ui-surface-darker)] border border-t-0 border-[var(--ui-surface-dark-border)] text-foreground shadow-md",
              "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
              "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
              i
            ),
            position: "popper",
            sideOffset: 0,
            children: [
              k ? /* @__PURE__ */ c("style", { children: `
                    [data-ui-select-scrollbar='true'] [data-radix-select-viewport] {
                      scrollbar-width: thin !important;
                      -ms-overflow-style: auto !important;
                    }
                    [data-ui-select-scrollbar='true'] [data-radix-select-viewport]::-webkit-scrollbar {
                      display: block !important;
                      width: 6px !important;
                    }
                    [data-ui-select-scrollbar='true'] [data-radix-select-viewport]::-webkit-scrollbar-button {
                      display: none !important;
                      width: 0 !important;
                      height: 0 !important;
                    }
                    [data-ui-select-scrollbar='true'] [data-radix-select-viewport]::-webkit-scrollbar-track {
                      background: transparent !important;
                    }
                    [data-ui-select-scrollbar='true'] [data-radix-select-viewport]::-webkit-scrollbar-thumb {
                      background: var(--ui-scrollbar-thumb) !important;
                      border-radius: 9999px !important;
                    }
                    [data-ui-select-scrollbar='true'] .ui-select-scroll-button {
                      display: none !important;
                    }
                  ` }) : null,
              W ? /* @__PURE__ */ c(Te.ScrollUpButton, { className: "ui-select-scroll-button flex cursor-default items-center justify-center py-1", children: /* @__PURE__ */ c("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5 15l7-7 7 7" }) }) }) : null,
              /* @__PURE__ */ c(
                Te.Viewport,
                {
                  className: b(
                    "p-1 h-[var(--radix-select-trigger-width)] max-h-[300px] w-full min-w-[var(--radix-select-trigger-width)]",
                    T
                  ),
                  children: l
                }
              ),
              W ? /* @__PURE__ */ c(Te.ScrollDownButton, { className: "ui-select-scroll-button flex cursor-default items-center justify-center py-1", children: /* @__PURE__ */ c("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }) }) }) : null
            ]
          }
        ) })
      ] }),
      y && N && /* @__PURE__ */ c("p", { className: "mt-1.5 text-xs text-danger", children: y })
    ] });
  }
);
on.displayName = "Select";
const an = m.forwardRef(
  ({ className: e, children: t, startContent: n, ...r }, o) => /* @__PURE__ */ Y(
    Te.Item,
    {
      ref: o,
      className: b(
        "relative flex w-full cursor-pointer select-none items-center rounded-md py-2 px-3 text-sm outline-none",
        "text-foreground hover:bg-[var(--ui-surface-dark-hover)] focus:bg-[var(--ui-surface-dark-hover)]",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        e
      ),
      ...r,
      children: [
        n && /* @__PURE__ */ c("span", { className: "mr-2 flex shrink-0 items-center", children: n }),
        /* @__PURE__ */ c(Te.ItemText, { children: t })
      ]
    }
  )
);
an.displayName = "SelectItem";
const xr = ce(
  "flex items-center justify-between rounded-md border px-3 py-2 text-sm text-default-700 transition-colors",
  {
    variants: {
      variant: {
        flat: "bg-default-100 border-transparent",
        bordered: "bg-transparent border-default-200",
        faded: "bg-default-50 border-default-200",
        admin: "bg-transparent border border-input px-2 gap-2"
      },
      size: {
        sm: "h-8 text-xs",
        md: "h-10 text-sm",
        lg: "h-12 text-base"
      }
    },
    defaultVariants: {
      variant: "bordered",
      size: "md"
    }
  }
), sn = "en", kr = (e) => e && e.trim() ? e.trim() : typeof document < "u" && document.documentElement.lang ? document.documentElement.lang : typeof navigator < "u" && navigator.language ? navigator.language : sn, Mr = (e) => e.toLowerCase().split("-")[0] || sn, Dr = (e) => Mr(e) === sn ? 0 : 1;
function Nr(e) {
  const t = kr(e), n = Sr(t);
  return {
    localeCode: t,
    formatters: n,
    weekStartsOn: Dr(t)
  };
}
const Sr = (e) => {
  const t = new Intl.DateTimeFormat(e, { month: "long", year: "numeric" }), n = new Intl.DateTimeFormat(e, { month: "long" }), r = new Intl.DateTimeFormat(e, { weekday: "short" }), o = new Intl.DateTimeFormat(e, { year: "numeric" });
  return {
    formatCaption: (a) => t.format(a),
    formatMonthDropdown: (a) => n.format(a),
    formatWeekdayName: (a) => {
      const s = r.format(a).replace(".", "");
      return s.length > 2 ? s.slice(0, 2) : s;
    },
    formatYearDropdown: (a) => o.format(a)
  };
}, Cn = ({
  options: e,
  value: t,
  onChange: n,
  disabled: r,
  className: o,
  tone: a = "default"
}) => {
  const s = o?.includes("years_dropdown") || (e?.length ?? 0) > 12, i = t != null ? String(t) : void 0, l = (f) => {
    n && n({ target: { value: f } });
  }, d = a === "dark";
  return /* @__PURE__ */ c("div", { className: b("min-w-[90px]", o), children: /* @__PURE__ */ c(
    on,
    {
      value: i,
      onValueChange: l,
      disabled: r,
      size: "sm",
      variant: "flat",
      showScrollButtons: !1,
      showViewportScrollbar: !0,
      renderValue: (f) => {
        const u = e?.find((g) => String(g.value) === f)?.label ?? f;
        return /* @__PURE__ */ c("span", { className: b("truncate", s && "w-full text-right tabular-nums"), children: u });
      },
      className: "gap-0",
      viewportClassName: b(
        "overflow-y-scroll overscroll-contain p-1 [scrollbar-width:thin] [scrollbar-color:var(--ui-scrollbar-thumb)_transparent]",
        "[&::-webkit-scrollbar]:w-1.5",
        "[&::-webkit-scrollbar-track]:bg-transparent",
        "[&::-webkit-scrollbar-thumb]:rounded-full",
        "[&::-webkit-scrollbar-thumb]:bg-[var(--ui-scrollbar-thumb)]",
        "h-[216px] max-h-[216px]"
      ),
      triggerClassName: b(
        "h-8 rounded-xl px-3 text-sm focus:ring-1 data-[state=open]:rounded-xl",
        d ? "border border-white/15 bg-[#2e2e32] text-white focus:ring-[#F4A425]/50" : "border border-default-200 bg-content1 text-default-700 focus:ring-warning/60"
      ),
      contentClassName: b(
        "shadow-small",
        d ? "rounded-xl border border-white/10 bg-[#2e2e32] text-white" : "rounded-md border border-default-200 bg-content1 text-default-700"
      ),
      children: e?.map((f) => /* @__PURE__ */ c(
        an,
        {
          value: String(f.value),
          disabled: f.disabled,
          className: b(
            "w-full",
            d ? "text-white hover:bg-white/10 focus:bg-white/10" : "text-default-700 hover:bg-default-100/70 focus:bg-default-100/70",
            s && "justify-end pr-4 text-right tabular-nums"
          ),
          children: f.label
        },
        f.value
      ))
    }
  ) });
}, Ui = {
  root: "w-fit overflow-hidden rounded-md bg-content1",
  months: "flex w-full",
  month: "relative w-full bg-content1",
  month_caption: "relative flex h-12 items-center justify-center border-b border-default-200 bg-content2 px-10",
  caption_label: "inline-flex items-center truncate text-sm leading-none font-medium text-default-500 capitalize",
  dropdowns: "flex items-center justify-center gap-2",
  months_dropdown: "w-full",
  years_dropdown: "w-full",
  nav: "hidden",
  button_previous: "absolute left-2 top-6 z-10 inline-flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-default-500 hover:bg-default-200/50 hover:text-default-600 transition-colors",
  button_next: "absolute right-2 top-6 z-10 inline-flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-default-500 hover:bg-default-200/50 hover:text-default-600 transition-colors",
  chevron: "h-4 w-4 shrink-0 fill-current text-default-500",
  month_grid: "w-full border-collapse",
  weekdays: "border-b border-default-200 bg-content2",
  weekday: "h-9 w-10 text-center text-xs font-medium text-default-500",
  weeks: "bg-content1",
  week: "h-10",
  day: "h-10 w-10 p-0 text-center align-middle",
  day_button: "mx-auto flex h-8 w-8 items-center justify-center rounded-full text-sm leading-none font-normal text-default-700 transition-colors hover:bg-default-100/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warning/70",
  selected: "[&>button]:bg-info [&>button]:text-[var(--ui-text-on-dark)] [&>button]:hover:bg-info",
  today: "[&>button]:ring-1 [&>button]:ring-default-300/40",
  outside: "[&>button]:text-default-400 [&>button]:opacity-70",
  disabled: "[&>button]:text-default-300 [&>button]:opacity-40",
  hidden: "invisible",
  range_start: "bg-transparent",
  range_middle: "bg-transparent",
  range_end: "bg-transparent"
}, Zi = "rounded-2xl border border-white/12 bg-[#1a1a1d] shadow-[0_24px_48px_rgba(0,0,0,0.55)] ring-1 ring-black/40", Lt = "[&>button]:bg-[radial-gradient(93.48%_107.58%_at_50%_-7.58%,#FEC930_0%,#F4A425_100%)] [&>button]:font-semibold [&>button]:text-[#070707] [&>button]:shadow-[0_2px_10px_rgba(244,164,37,0.45)] [&>button]:!ring-0 [&>button]:hover:brightness-[1.03]", Qi = {
  root: "w-fit overflow-hidden rounded-2xl bg-[#1a1a1d] p-2",
  months: "flex w-full",
  month: "relative w-full bg-[#1a1a1d]",
  month_caption: "relative flex h-[52px] items-center justify-center border-b border-white/10 bg-[#202024] px-10 pt-0.5",
  caption_label: "inline-flex items-center truncate text-[15px] font-medium leading-none text-white capitalize",
  dropdowns: "flex items-center justify-center gap-2",
  months_dropdown: "w-full",
  years_dropdown: "w-full",
  nav: "hidden",
  button_previous: "absolute left-2 top-[26px] z-10 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-neutral-400 transition-colors hover:bg-white/10 hover:text-white",
  button_next: "absolute right-2 top-[26px] z-10 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-neutral-400 transition-colors hover:bg-white/10 hover:text-white",
  chevron: "h-4 w-4 shrink-0 fill-current text-neutral-400",
  month_grid: "w-full border-collapse",
  weekdays: "border-b border-white/10 bg-[#202024]",
  weekday: "h-10 w-11 p-0 text-center text-[11px] font-semibold uppercase leading-none tracking-[0.08em] text-neutral-500 first:pl-0 last:pr-0",
  weeks: "bg-[#1a1a1d]",
  week: "h-11",
  day: "h-11 w-11 p-0 text-center align-middle",
  day_button: "mx-auto flex h-9 w-9 items-center justify-center rounded-full text-[13px] font-medium leading-none text-neutral-100 transition-[color,background-color,box-shadow] duration-150 hover:bg-white/[0.08] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4A425]/60",
  selected: "[&>button]:bg-[radial-gradient(93.48%_107.58%_at_50%_-7.58%,#FEC930_0%,#F4A425_100%)] [&>button]:font-semibold [&>button]:text-[#070707] [&>button]:shadow-[0_2px_10px_rgba(244,164,37,0.45)] [&>button]:!ring-0 [&>button]:hover:brightness-[1.03]",
  today: "[&>button]:ring-2 [&>button]:ring-[#F4A425]/55 [&>button]:ring-offset-0 [&>button]:ring-offset-transparent",
  outside: "[&>button]:text-neutral-600 [&>button]:opacity-70",
  disabled: "[&>button]:text-neutral-600 [&>button]:opacity-35",
  hidden: "invisible",
  range_start: Lt,
  range_middle: Lt,
  range_end: Lt
}, _t = ({
  className: e,
  classNames: t,
  tone: n = "default",
  showOutsideDays: r = !0,
  ...o
}) => {
  const a = n === "dark" ? Qi : Ui, s = n === "dark" ? (i) => /* @__PURE__ */ c(Cn, { ...i, tone: "dark" }) : Cn;
  return /* @__PURE__ */ c(
    qi,
    {
      showOutsideDays: r,
      className: b("p-0", e),
      navLayout: "around",
      components: {
        Dropdown: s
      },
      classNames: {
        ...a,
        ...t
      },
      ...o
    }
  );
};
_t.displayName = "Calendar";
const Xi = m.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    value: r,
    onChange: o,
    placeholder: a = "Select date",
    format: s = "DD MMMM YYYY",
    locale: i,
    disabled: l,
    minDate: d,
    maxDate: f,
    fromYear: u,
    toYear: g,
    clearable: p,
    closeOnSelect: h = !0,
    popoverContentClassName: D,
    calendarTone: N = "default",
    ...y
  }, T) => {
    const [W, k] = m.useState(!1), v = kr(i), w = Mr(v), $ = Sr(v), L = Dr(v), B = (/* @__PURE__ */ new Date()).getFullYear(), I = u ?? (d ? d.getUTCFullYear() : B - 50), R = g ?? (f ? f.getUTCFullYear() : B + 10), X = Math.min(I, R), V = Math.max(I, R);
    return /* @__PURE__ */ Y(Le.Root, { open: W, onOpenChange: k, children: [
      /* @__PURE__ */ c(Le.Trigger, { asChild: !0, children: /* @__PURE__ */ Y(
        "button",
        {
          type: "button",
          className: b(
            xr({ variant: t, size: n }),
            !r && "text-muted-foreground",
            l && "opacity-50 cursor-not-allowed",
            e
          ),
          disabled: l,
          children: [
            /* @__PURE__ */ c("span", { children: r ? $e(r).locale(w).format(s) : a }),
            /* @__PURE__ */ Y("span", { className: "ml-auto flex items-center gap-1", children: [
              p && r && /* @__PURE__ */ c(
                "span",
                {
                  role: "button",
                  tabIndex: -1,
                  onClick: (O) => {
                    O.stopPropagation(), o?.(void 0);
                  },
                  onKeyDown: (O) => {
                    (O.key === "Enter" || O.key === " ") && (O.stopPropagation(), o?.(void 0));
                  },
                  className: "h-4 w-4 opacity-50 hover:opacity-100 transition-opacity cursor-pointer",
                  children: /* @__PURE__ */ Y(
                    "svg",
                    {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      children: [
                        /* @__PURE__ */ c("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
                        /* @__PURE__ */ c("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
                      ]
                    }
                  )
                }
              ),
              /* @__PURE__ */ c(Xr, { className: "h-4 w-4 opacity-50" })
            ] })
          ]
        }
      ) }),
      /* @__PURE__ */ c(Le.Portal, { children: /* @__PURE__ */ c(
        Le.Content,
        {
          className: b(
            "z-50 w-auto overflow-hidden p-0",
            N === "dark" ? Zi : "rounded-md border border-default-200 bg-content1 shadow-small",
            D
          ),
          align: "start",
          sideOffset: 8,
          children: /* @__PURE__ */ c(
            _t,
            {
              tone: N,
              mode: "single",
              captionLayout: "dropdown",
              selected: r,
              onSelect: (O) => {
                o?.(O), h && k(!1);
              },
              formatters: $,
              weekStartsOn: L,
              fromYear: X,
              toYear: V,
              disabled: d || f ? (O) => !!(d && O < d || f && O > f) : void 0,
              initialFocus: !0
            }
          )
        }
      ) })
    ] });
  }
);
Xi.displayName = "DatePicker";
const Ji = m.forwardRef(
  ({
    value: e,
    onChange: t,
    placeholder: n = "DD.MM.YY",
    minDate: r,
    maxDate: o,
    format: a = "DD.MM.YY",
    className: s,
    locale: i
  }, l) => {
    const [d, f] = m.useState(!1), [u, g] = m.useState({}), p = m.useRef(null), h = m.useRef(null), { formatters: D, weekStartsOn: N } = m.useMemo(
      () => Nr(i),
      [i]
    ), y = () => {
      const k = p.current;
      if (!d && k) {
        const v = k.getBoundingClientRect();
        g({
          position: "fixed",
          top: v.bottom + 4,
          left: v.left,
          zIndex: 9999,
          width: Math.min(310, window.innerWidth - 24)
        });
      }
      f((v) => !v);
    };
    m.useEffect(() => {
      if (!d) return;
      const k = (v) => {
        !h.current?.contains(v.target) && !p.current?.contains(v.target) && f(!1);
      };
      return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
    }, [d]);
    const T = e ? /* @__PURE__ */ new Date(`${e}T12:00:00`) : void 0, W = e ? $e(e).format(a) : n;
    return /* @__PURE__ */ Y(Ge, { children: [
      /* @__PURE__ */ Y(
        "button",
        {
          ref: (k) => {
            p.current = k, typeof l == "function" ? l(k) : l && (l.current = k);
          },
          type: "button",
          onClick: y,
          className: b(
            "flex w-full items-center justify-between gap-2 rounded-xl bg-black/55 px-4 text-sm",
            "h-11 cursor-pointer border-none outline-none",
            s
          ),
          children: [
            /* @__PURE__ */ c("span", { className: e ? "text-[#f2f2f2]" : "text-[#8c8c8c]", children: W }),
            /* @__PURE__ */ c("img", { src: "/images/icons/calendar_icon.svg", alt: "", width: 20, height: 20, decoding: "async" })
          ]
        }
      ),
      d && typeof document < "u" && $n(
        /* @__PURE__ */ c("div", { ref: h, style: u, className: In, children: /* @__PURE__ */ c("div", { className: "flex justify-center overflow-x-auto", children: /* @__PURE__ */ c(
          _t,
          {
            tone: "dark",
            mode: "single",
            selected: T,
            defaultMonth: T,
            onSelect: (k) => {
              k && (t?.($e(k).format("YYYY-MM-DD")), f(!1));
            },
            formatters: D,
            weekStartsOn: N,
            disabled: (k) => !!(r && k < /* @__PURE__ */ new Date(`${r}T00:00:00`) || o && k > /* @__PURE__ */ new Date(`${o}T23:59:59`)),
            classNames: Rn,
            initialFocus: !0
          }
        ) }) }),
        document.body
      )
    ] });
  }
);
Ji.displayName = "GlassDatePicker";
const Ki = m.forwardRef(
  ({
    from: e,
    to: t,
    onChange: n,
    onClear: r,
    placeholder: o = "Select period",
    format: a = "DD.MM.YY",
    applyLabel: s = "Apply",
    cancelLabel: i = "Cancel",
    maxDate: l,
    className: d,
    locale: f,
    placement: u = "auto"
  }, g) => {
    const [p, h] = m.useState(!1), [D, N] = m.useState({}), [y, T] = m.useState(), [W, k] = m.useState(), v = m.useRef(null), w = m.useRef(null), { formatters: $, weekStartsOn: L } = m.useMemo(() => Nr(f), [f]), B = () => {
      const S = v.current;
      if (!p && S) {
        const x = S.getBoundingClientRect(), C = Math.min(330, window.innerWidth - 24), F = 420, j = window.innerHeight - x.bottom, Z = u === "top" ? !0 : u === "bottom" ? !1 : j < F, Q = window.innerWidth < 480, K = (window.innerWidth - C) / 2, ee = Math.min(Math.max(x.left, 12), window.innerWidth - C - 12), le = Q ? K : ee;
        if (Z) {
          const ue = x.top - F - 4;
          if (ue >= 8)
            N({
              position: "fixed",
              top: ue,
              left: le,
              zIndex: 9999,
              width: C
            });
          else {
            const he = x.bottom + 8;
            if (he + F <= window.innerHeight - 8)
              N({
                position: "fixed",
                top: he,
                left: le,
                zIndex: 9999,
                width: C
              });
            else {
              const U = Math.max(8, Math.round((window.innerHeight - F) / 2));
              N({
                position: "fixed",
                top: U,
                left: le,
                zIndex: 9999,
                width: C
              });
            }
          }
        } else
          N({
            position: "fixed",
            top: x.bottom + 20,
            left: le,
            zIndex: 9999,
            width: C
          });
        T(e ? /* @__PURE__ */ new Date(`${e}T12:00:00`) : void 0), k(t ? /* @__PURE__ */ new Date(`${t}T12:00:00`) : void 0);
      }
      h((x) => !x);
    }, I = () => {
      if (!y || !W) return;
      let S = $e(y), x = $e(W);
      x.isBefore(S) && ([S, x] = [x, S]), n(S.format("YYYY-MM-DD"), x.format("YYYY-MM-DD")), h(!1);
    }, R = () => {
      h(!1);
    }, X = (S) => {
      T(S?.from), k(S?.to);
    };
    m.useEffect(() => {
      if (!p) return;
      const S = (x) => {
        const C = x.composedPath?.() ?? [];
        w.current && C.includes(w.current) || v.current?.contains(x.target) || h(!1);
      };
      return document.addEventListener("click", S), () => document.removeEventListener("click", S);
    }, [p]);
    const V = m.useMemo(() => {
      if (y)
        return { from: y, to: W };
    }, [y, W]), O = y ?? W ?? /* @__PURE__ */ new Date(), _ = $e().startOf("day"), M = e && t ? `${$e(e).format(a)} — ${$e(t).format(a)}` : e ? `${$e(e).format(a)} — ...` : void 0;
    return /* @__PURE__ */ Y(Ge, { children: [
      /* @__PURE__ */ Y(
        "button",
        {
          ref: (S) => {
            v.current = S, typeof g == "function" ? g(S) : g && (g.current = S);
          },
          type: "button",
          onClick: B,
          className: b(
            "flex w-full items-center justify-between gap-2 rounded-xl bg-black/55 px-4 text-sm",
            "h-11 cursor-pointer border-none outline-none",
            d
          ),
          children: [
            /* @__PURE__ */ c("span", { className: M ? "text-[#f2f2f2]" : "text-[#8c8c8c]", children: M ?? o }),
            /* @__PURE__ */ c("img", { src: "/images/icons/calendar_icon.svg", alt: "", width: 20, height: 20, decoding: "async" })
          ]
        }
      ),
      p && typeof document < "u" && $n(
        /* @__PURE__ */ Y("div", { ref: w, style: { ...D, pointerEvents: "auto" }, className: In, "data-glass-datepicker": "panel", children: [
          /* @__PURE__ */ c("div", { className: "flex justify-center overflow-x-auto", children: /* @__PURE__ */ c(
            _t,
            {
              tone: "dark",
              mode: "range",
              numberOfMonths: 1,
              defaultMonth: O,
              selected: V,
              onSelect: X,
              formatters: $,
              weekStartsOn: L,
              disabled: (S) => l && S > /* @__PURE__ */ new Date(`${l}T23:59:59`) ? !0 : $e(S).startOf("day").isAfter(_),
              classNames: Rn,
              initialFocus: !0
            }
          ) }),
          /* @__PURE__ */ Y("div", { className: "mt-3 flex gap-2", children: [
            /* @__PURE__ */ c(ht, { size: "md", className: "flex-1 bg-white/10 backdrop-blur-md", onClick: R, children: i }),
            /* @__PURE__ */ c(
              ht,
              {
                variant: "glow",
                size: "md",
                className: "flex-1",
                onClick: I,
                disabled: !y || !W,
                children: s
              }
            )
          ] })
        ] }),
        document.body
      )
    ] });
  }
);
Ki.displayName = "GlassRangeDatePicker";
const el = ce(
  "flex w-full rounded-lg text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium outline-none placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border border-input bg-background",
        flat: "bg-[var(--ui-surface-dark)] border border-[var(--ui-surface-dark-border)]",
        bordered: "border-2 border-default-200 bg-transparent",
        faded: "border border-default-200 bg-default-100",
        underlined: "rounded-none border-0 border-b-2 border-default-200 bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary",
        modal: "bg-[var(--ui-surface-dark-hover)] border border-[var(--ui-color-label-muted)] text-foreground text-center placeholder:text-default-400",
        dark: "bg-[var(--ui-surface-dark)] border border-[var(--ui-surface-dark-border)] text-foreground placeholder:text-default-400",
        glass: "bg-[var(--ui-surface-glass)] border border-[var(--ui-surface-glass-border)] backdrop-blur-sm text-foreground placeholder:text-default-400",
        "grey-15": "bg-[#8C8C8C]/15 border border-[#8C8C8C]/15 text-foreground placeholder:text-[#8C8C8C]"
      },
      inputSize: {
        sm: "h-8 px-2 text-xs",
        md: "h-10 px-3",
        lg: "h-[56px] px-4 text-base"
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
        full: "rounded-full"
      },
      isInvalid: {
        true: "border-danger focus-visible:ring-danger"
      }
    },
    defaultVariants: {
      variant: "default",
      inputSize: "md",
      radius: "lg"
    }
  }
), tl = ce("relative w-full", {
  variants: {
    fullWidth: {
      true: "w-full",
      false: "w-auto"
    }
  },
  defaultVariants: {
    fullWidth: !0
  }
}), Or = m.forwardRef(
  ({
    className: e,
    type: t = "text",
    variant: n,
    inputSize: r,
    radius: o,
    isInvalid: a,
    label: s,
    description: i,
    errorMessage: l,
    startContent: d,
    endContent: f,
    labelPlacement: u = "outside",
    fullWidth: g = !0,
    isRequired: p,
    isClearable: h,
    hideNumberControls: D = !0,
    onClear: N,
    value: y,
    ...T
  }, W) => {
    const [k, v] = m.useState(!1), w = h && y && String(y).length > 0, $ = y !== void 0 ? String(y).length > 0 : !!T.defaultValue, B = !!T.placeholder || k || $, { onFocus: I, onBlur: R, onWheel: X, ...V } = T;
    return /* @__PURE__ */ Y("div", { className: b(tl({ fullWidth: g })), children: [
      s && u === "outside" && /* @__PURE__ */ Y("label", { className: "mb-1.5 block text-sm font-medium text-foreground", children: [
        s,
        p && /* @__PURE__ */ c("span", { className: "ml-0.5 text-danger", children: "*" })
      ] }),
      /* @__PURE__ */ Y("div", { className: "relative", children: [
        d && /* @__PURE__ */ c("div", { className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3", children: d }),
        /* @__PURE__ */ c(
          "input",
          {
            type: t,
            className: b(
              el({ variant: n, inputSize: r, radius: o, isInvalid: a }),
              t === "number" && D && "[appearance:textfield] [-moz-appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
              d && "pl-10",
              (f || w) && "pr-10",
              u === "inside" && s && "pt-4 pb-0",
              e
            ),
            ref: W,
            value: y,
            onFocus: (O) => {
              v(!0), I?.(O);
            },
            onBlur: (O) => {
              v(!1), R?.(O);
            },
            onWheel: (O) => {
              t === "number" && O.currentTarget.blur(), X?.(O);
            },
            ...V
          }
        ),
        s && u === "inside" && /* @__PURE__ */ Y(
          "label",
          {
            className: b(
              "pointer-events-none absolute transition-all duration-150 text-[var(--ui-color-label-muted)]",
              d ? "left-10" : "left-4",
              B ? "top-1 text-xs" : "top-1/2 -translate-y-1/2 text-sm"
            ),
            children: [
              s,
              p && /* @__PURE__ */ c("span", { className: "ml-0.5 text-danger", children: "*" })
            ]
          }
        ),
        (f || w) && /* @__PURE__ */ c("div", { className: "absolute inset-y-0 right-0 flex items-center pr-3", children: w ? /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            onClick: N,
            className: "text-default-400 hover:text-default-600 transition-colors",
            children: /* @__PURE__ */ c("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
          }
        ) : f })
      ] }),
      i && !l && /* @__PURE__ */ c("p", { className: "mt-1.5 text-xs text-default-400", children: i }),
      l && a && /* @__PURE__ */ c("p", { className: "mt-1.5 text-xs text-danger", children: l })
    ] });
  }
);
Or.displayName = "Input";
const nl = ({ open: e, className: t }) => /* @__PURE__ */ c(
  Jr,
  {
    className: b("shrink-0 opacity-50 transition-transform duration-200", e && "rotate-180", t),
    style: { width: 14, height: 14 }
  }
), Cr = m.forwardRef(
  ({
    options: e,
    value: t,
    onValueChange: n,
    placeholder: r = "Select...",
    searchPlaceholder: o = "Search...",
    disabled: a,
    startContent: s,
    endContent: i,
    emptyText: l = "No results",
    variant: d = "flat",
    inputSize: f = "md",
    className: u,
    label: g,
    isRequired: p,
    errorMessage: h,
    isInvalid: D,
    inputClassName: N,
    dropdownClassName: y,
    isClearable: T,
    showChevron: W = !0,
    chevronClassName: k
  }, v) => {
    const [w, $] = m.useState(!1), [L, B] = m.useState(""), [I, R] = m.useState(!1), [X, V] = m.useState(!1), [O, _] = m.useState({}), M = m.useRef(null), S = m.useRef(null);
    m.useEffect(() => {
      V(!0);
    }, []);
    const x = e.find((E) => E.value === t), C = w && I ? L : x?.label ?? "", F = w && I && !L || x?.listLabel ? s : x?.startContent ?? s, Z = /* @__PURE__ */ Y(
      "span",
      {
        className: "flex items-center gap-2 cursor-pointer",
        onMouseDown: (E) => {
          E.preventDefault(), E.stopPropagation(), !a && (w ? le() : ee());
        },
        onClick: (E) => E.stopPropagation(),
        children: [
          i,
          T && !!t && !a && /* @__PURE__ */ c(
            "span",
            {
              role: "button",
              "aria-label": "Clear",
              className: "flex items-center justify-center opacity-60 hover:opacity-100",
              onMouseDown: (E) => {
                E.preventDefault(), E.stopPropagation(), n?.(""), B(""), R(!1);
              },
              children: /* @__PURE__ */ Y("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
                /* @__PURE__ */ c("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
                /* @__PURE__ */ c("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
              ] })
            }
          ),
          W && /* @__PURE__ */ c(nl, { open: w, className: k })
        ]
      }
    ), Q = m.useMemo(() => {
      if (!L) return e;
      const E = L.toLowerCase();
      return e.filter((U) => (U.searchText ?? `${U.label} ${U.value} ${U.listLabel ?? ""}`).toLowerCase().includes(E));
    }, [e, L]), K = () => {
      if (!M.current) return;
      const E = M.current.getBoundingClientRect(), U = window.innerHeight, se = U - E.bottom, be = E.top, Se = se < 200 && be > se, z = Math.max(140, Math.min(280, (Se ? be : se) - 12));
      _({
        position: "fixed",
        top: Se ? void 0 : E.bottom + 6,
        bottom: Se ? U - E.top + 6 : void 0,
        left: E.left,
        width: E.width,
        maxHeight: z,
        boxSizing: "border-box",
        zIndex: 10010
      });
    }, ee = () => {
      R(!1), K(), $(!0);
    }, le = () => {
      $(!1), B(""), R(!1);
    }, ue = (E) => {
      n?.(E.value), le();
    };
    m.useEffect(() => {
      if (!w) return;
      const E = (U) => {
        const se = U.target;
        M.current?.contains(se) || S.current?.contains(se) || le();
      };
      return document.addEventListener("mousedown", E), () => document.removeEventListener("mousedown", E);
    }, [w]), m.useEffect(() => {
      if (!w) return;
      const E = () => K();
      return window.addEventListener("scroll", E, !0), window.addEventListener("resize", E), () => {
        window.removeEventListener("scroll", E, !0), window.removeEventListener("resize", E);
      };
    }, [w]), m.useEffect(() => {
      if (!w) return;
      const E = S.current;
      if (!E) return;
      const U = (se) => {
        se.preventDefault(), se.stopPropagation(), E.scrollTop += se.deltaY;
      };
      return E.addEventListener("wheel", U, { passive: !1 }), () => E.removeEventListener("wheel", U);
    }, [w, Q.length]);
    const he = w && X ? to.createPortal(
      /* @__PURE__ */ Y(
        "div",
        {
          ref: S,
          style: { ...O, pointerEvents: "auto" },
          "data-combobox-dropdown": "",
          className: b(
            "overflow-y-auto overflow-x-hidden overscroll-contain rounded-xl border border-[rgba(140,140,140,0.28)] bg-[rgba(22,22,24,0.97)] shadow-[0_12px_40px_rgba(0,0,0,0.45)] backdrop-blur-xl",
            "p-1.5",
            y
          ),
          children: [
            Q.map((E) => /* @__PURE__ */ Y(
              "div",
              {
                className: b(
                  "relative flex w-full items-center gap-2.5 px-2.5 py-2 cursor-pointer select-none rounded-lg text-[length:inherit] font-[number:inherit] text-foreground outline-none transition-colors",
                  "hover:bg-white/8",
                  E.value === t && "bg-white/10"
                ),
                onMouseDown: (U) => {
                  U.preventDefault(), ue(E);
                },
                children: [
                  E.startContent && /* @__PURE__ */ c("span", { className: "flex-shrink-0 pointer-events-none", children: E.startContent }),
                  /* @__PURE__ */ c("span", { className: "min-w-0 flex-1 truncate", title: E.label, children: E.listLabel ?? E.label })
                ]
              },
              E.value
            )),
            Q.length === 0 && /* @__PURE__ */ c("div", { className: "px-2.5 py-3 text-sm text-white/40", children: l })
          ]
        }
      ),
      document.body
    ) : null;
    return /* @__PURE__ */ Y(
      "div",
      {
        ref: (E) => {
          M.current = E, typeof v == "function" ? v(E) : v && (v.current = E);
        },
        className: b("relative w-full", !a && "cursor-pointer", u),
        onMouseDown: (E) => {
          if (!a && !S.current?.contains(E.target)) {
            if (E.preventDefault(), w) {
              le();
              return;
            }
            ee(), M.current?.querySelector("input")?.focus();
          }
        },
        children: [
          /* @__PURE__ */ c(
            Or,
            {
              value: C,
              onChange: (E) => {
                B(E.target.value), R(!0), w || ee();
              },
              onFocus: () => {
                w || ee();
              },
              onClick: (E) => {
                E.stopPropagation();
              },
              placeholder: w ? o : r,
              disabled: a,
              startContent: F,
              endContent: Z,
              variant: d,
              inputSize: f,
              label: g,
              isRequired: p,
              errorMessage: h,
              isInvalid: D,
              className: b(
                !a && "cursor-pointer",
                w && "rounded-b-none focus-visible:ring-0 focus-visible:ring-offset-0",
                N
              )
            }
          ),
          he
        ]
      }
    );
  }
);
Cr.displayName = "Combobox";
const rl = m.forwardRef(
  ({ className: e, validationBehavior: t = "native", ...n }, r) => /* @__PURE__ */ c(
    "form",
    {
      ref: r,
      className: b(e),
      noValidate: t === "aria",
      ...n
    }
  )
);
rl.displayName = "Form";
var ol = Object.defineProperty, al = Object.defineProperties, sl = Object.getOwnPropertyDescriptors, Nt = Object.getOwnPropertySymbols, Wr = Object.prototype.hasOwnProperty, _r = Object.prototype.propertyIsEnumerable, Wn = (e, t, n) => t in e ? ol(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, il = (e, t) => {
  for (var n in t || (t = {})) Wr.call(t, n) && Wn(e, n, t[n]);
  if (Nt) for (var n of Nt(t)) _r.call(t, n) && Wn(e, n, t[n]);
  return e;
}, ll = (e, t) => al(e, sl(t)), cl = (e, t) => {
  var n = {};
  for (var r in e) Wr.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Nt) for (var r of Nt(e)) t.indexOf(r) < 0 && _r.call(e, r) && (n[r] = e[r]);
  return n;
};
function dl(e) {
  let t = setTimeout(e, 0), n = setTimeout(e, 10), r = setTimeout(e, 50);
  return [t, n, r];
}
function ul(e) {
  let t = m.useRef();
  return m.useEffect(() => {
    t.current = e;
  }), t.current;
}
var fl = 18, Tr = 40, ml = `${Tr}px`, hl = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function pl({ containerRef: e, inputRef: t, pushPasswordManagerStrategy: n, isFocused: r }) {
  let [o, a] = m.useState(!1), [s, i] = m.useState(!1), [l, d] = m.useState(!1), f = m.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && o && s, [o, s, n]), u = m.useCallback(() => {
    let g = e.current, p = t.current;
    if (!g || !p || l || n === "none") return;
    let h = g, D = h.getBoundingClientRect().left + h.offsetWidth, N = h.getBoundingClientRect().top + h.offsetHeight / 2, y = D - fl, T = N;
    document.querySelectorAll(hl).length === 0 && document.elementFromPoint(y, T) === g || (a(!0), d(!0));
  }, [e, t, l, n]);
  return m.useEffect(() => {
    let g = e.current;
    if (!g || n === "none") return;
    function p() {
      let D = window.innerWidth - g.getBoundingClientRect().right;
      i(D >= Tr);
    }
    p();
    let h = setInterval(p, 1e3);
    return () => {
      clearInterval(h);
    };
  }, [e, n]), m.useEffect(() => {
    let g = r || document.activeElement === t.current;
    if (n === "none" || !g) return;
    let p = setTimeout(u, 0), h = setTimeout(u, 2e3), D = setTimeout(u, 5e3), N = setTimeout(() => {
      d(!0);
    }, 6e3);
    return () => {
      clearTimeout(p), clearTimeout(h), clearTimeout(D), clearTimeout(N);
    };
  }, [t, r, n, u]), { hasPWMBadge: o, willPushPWMBadge: f, PWM_BADGE_SPACE_WIDTH: ml };
}
var gl = m.createContext({}), Pr = m.forwardRef((e, t) => {
  var n = e, { value: r, onChange: o, maxLength: a, textAlign: s = "left", pattern: i, placeholder: l, inputMode: d = "numeric", onComplete: f, pushPasswordManagerStrategy: u = "increase-width", pasteTransformer: g, containerClassName: p, noScriptCSSFallback: h = bl, render: D, children: N } = n, y = cl(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), T, W, k, v, w;
  let [$, L] = m.useState(typeof y.defaultValue == "string" ? y.defaultValue : ""), B = r ?? $, I = ul(B), R = m.useCallback((z) => {
    o?.(z), L(z);
  }, [o]), X = m.useMemo(() => i ? typeof i == "string" ? new RegExp(i) : i : null, [i]), V = m.useRef(null), O = m.useRef(null), _ = m.useRef({ value: B, onChange: R, isIOS: typeof window < "u" && ((W = (T = window?.CSS) == null ? void 0 : T.supports) == null ? void 0 : W.call(T, "-webkit-touch-callout", "none")) }), M = m.useRef({ prev: [(k = V.current) == null ? void 0 : k.selectionStart, (v = V.current) == null ? void 0 : v.selectionEnd, (w = V.current) == null ? void 0 : w.selectionDirection] });
  m.useImperativeHandle(t, () => V.current, []), m.useEffect(() => {
    let z = V.current, q = O.current;
    if (!z || !q) return;
    _.current.value !== z.value && _.current.onChange(z.value), M.current.prev = [z.selectionStart, z.selectionEnd, z.selectionDirection];
    function fe() {
      if (document.activeElement !== z) {
        Z(null), K(null);
        return;
      }
      let ae = z.selectionStart, pe = z.selectionEnd, Ue = z.selectionDirection, ve = z.maxLength, Ee = z.value, xe = M.current.prev, Oe = -1, Ye = -1, Be;
      if (Ee.length !== 0 && ae !== null && pe !== null) {
        let Pt = ae === pe, Et = ae === Ee.length && Ee.length < ve;
        if (Pt && !Et) {
          let Ae = ae;
          if (Ae === 0) Oe = 0, Ye = 1, Be = "forward";
          else if (Ae === ve) Oe = Ae - 1, Ye = Ae, Be = "backward";
          else if (ve > 1 && Ee.length > 1) {
            let at = 0;
            if (xe[0] !== null && xe[1] !== null) {
              Be = Ae < xe[1] ? "backward" : "forward";
              let Yt = xe[0] === xe[1] && xe[0] < ve;
              Be === "backward" && !Yt && (at = -1);
            }
            Oe = at + Ae, Ye = at + Ae + 1;
          }
        }
        Oe !== -1 && Ye !== -1 && Oe !== Ye && V.current.setSelectionRange(Oe, Ye, Be);
      }
      let vt = Oe !== -1 ? Oe : ae, xt = Ye !== -1 ? Ye : pe, Tt = Be ?? Ue;
      Z(vt), K(xt), M.current.prev = [vt, xt, Tt];
    }
    if (document.addEventListener("selectionchange", fe, { capture: !0 }), fe(), document.activeElement === z && F(!0), !document.getElementById("input-otp-style")) {
      let ae = document.createElement("style");
      if (ae.id = "input-otp-style", document.head.appendChild(ae), ae.sheet) {
        let pe = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        lt(ae.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), lt(ae.sheet, `[data-input-otp]:autofill { ${pe} }`), lt(ae.sheet, `[data-input-otp]:-webkit-autofill { ${pe} }`), lt(ae.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), lt(ae.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let we = () => {
      q && q.style.setProperty("--root-height", `${z.clientHeight}px`);
    };
    we();
    let ye = new ResizeObserver(we);
    return ye.observe(z), () => {
      document.removeEventListener("selectionchange", fe, { capture: !0 }), ye.disconnect();
    };
  }, []);
  let [S, x] = m.useState(!1), [C, F] = m.useState(!1), [j, Z] = m.useState(null), [Q, K] = m.useState(null);
  m.useEffect(() => {
    dl(() => {
      var z, q, fe, we;
      (z = V.current) == null || z.dispatchEvent(new Event("input"));
      let ye = (q = V.current) == null ? void 0 : q.selectionStart, ae = (fe = V.current) == null ? void 0 : fe.selectionEnd, pe = (we = V.current) == null ? void 0 : we.selectionDirection;
      ye !== null && ae !== null && (Z(ye), K(ae), M.current.prev = [ye, ae, pe]);
    });
  }, [B, C]), m.useEffect(() => {
    I !== void 0 && B !== I && I.length < a && B.length === a && f?.(B);
  }, [a, f, I, B]);
  let ee = pl({ containerRef: O, inputRef: V, pushPasswordManagerStrategy: u, isFocused: C }), le = m.useCallback((z) => {
    let q = z.currentTarget.value.slice(0, a);
    if (q.length > 0 && X && !X.test(q)) {
      z.preventDefault();
      return;
    }
    typeof I == "string" && q.length < I.length && document.dispatchEvent(new Event("selectionchange")), R(q);
  }, [a, R, I, X]), ue = m.useCallback(() => {
    var z;
    if (V.current) {
      let q = Math.min(V.current.value.length, a - 1), fe = V.current.value.length;
      (z = V.current) == null || z.setSelectionRange(q, fe), Z(q), K(fe);
    }
    F(!0);
  }, [a]), he = m.useCallback((z) => {
    var q, fe;
    let we = V.current;
    if (!g && (!_.current.isIOS || !z.clipboardData || !we)) return;
    let ye = z.clipboardData.getData("text/plain"), ae = g ? g(ye) : ye;
    z.preventDefault();
    let pe = (q = V.current) == null ? void 0 : q.selectionStart, Ue = (fe = V.current) == null ? void 0 : fe.selectionEnd, ve = (pe !== Ue ? B.slice(0, pe) + ae + B.slice(Ue) : B.slice(0, pe) + ae + B.slice(pe)).slice(0, a);
    if (ve.length > 0 && X && !X.test(ve)) return;
    we.value = ve, R(ve);
    let Ee = Math.min(ve.length, a - 1), xe = ve.length;
    we.setSelectionRange(Ee, xe), Z(Ee), K(xe);
  }, [a, R, X, B]), E = m.useMemo(() => ({ position: "relative", cursor: y.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [y.disabled]), U = m.useMemo(() => ({ position: "absolute", inset: 0, width: ee.willPushPWMBadge ? `calc(100% + ${ee.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: ee.willPushPWMBadge ? `inset(0 ${ee.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: s, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [ee.PWM_BADGE_SPACE_WIDTH, ee.willPushPWMBadge, s]), se = m.useMemo(() => m.createElement("input", ll(il({ autoComplete: y.autoComplete || "one-time-code" }, y), { "data-input-otp": !0, "data-input-otp-placeholder-shown": B.length === 0 || void 0, "data-input-otp-mss": j, "data-input-otp-mse": Q, inputMode: d, pattern: X?.source, "aria-placeholder": l, style: U, maxLength: a, value: B, ref: V, onPaste: (z) => {
    var q;
    he(z), (q = y.onPaste) == null || q.call(y, z);
  }, onChange: le, onMouseOver: (z) => {
    var q;
    x(!0), (q = y.onMouseOver) == null || q.call(y, z);
  }, onMouseLeave: (z) => {
    var q;
    x(!1), (q = y.onMouseLeave) == null || q.call(y, z);
  }, onFocus: (z) => {
    var q;
    ue(), (q = y.onFocus) == null || q.call(y, z);
  }, onBlur: (z) => {
    var q;
    F(!1), (q = y.onBlur) == null || q.call(y, z);
  } })), [le, ue, he, d, U, a, Q, j, y, X?.source, B]), be = m.useMemo(() => ({ slots: Array.from({ length: a }).map((z, q) => {
    var fe;
    let we = C && j !== null && Q !== null && (j === Q && q === j || q >= j && q < Q), ye = B[q] !== void 0 ? B[q] : null, ae = B[0] !== void 0 ? null : (fe = l?.[q]) != null ? fe : null;
    return { char: ye, placeholderChar: ae, isActive: we, hasFakeCaret: we && ye === null };
  }), isFocused: C, isHovering: !y.disabled && S }), [C, S, a, Q, j, y.disabled, B]), Se = m.useMemo(() => D ? D(be) : m.createElement(gl.Provider, { value: be }, N), [N, be, D]);
  return m.createElement(m.Fragment, null, h !== null && m.createElement("noscript", null, m.createElement("style", null, h)), m.createElement("div", { ref: O, "data-input-otp-container": !0, style: E, className: p }, Se, m.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, se)));
});
Pr.displayName = "Input";
function lt(e, t) {
  try {
    e.insertRule(t);
  } catch {
    console.error("input-otp could not insert CSS rule:", t);
  }
}
var bl = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`;
const wl = ce("flex items-center gap-2", {
  variants: {
    variant: {
      flat: "",
      bordered: "",
      underlined: "",
      glass: ""
    },
    size: {
      sm: "gap-1.5",
      md: "gap-2",
      lg: "gap-3",
      xl: "gap-3"
    }
  },
  defaultVariants: {
    variant: "bordered",
    size: "md"
  }
}), yl = ce(
  "relative flex items-center justify-center border text-sm transition-all rounded-lg",
  {
    variants: {
      variant: {
        flat: "bg-default-100 border-transparent h-10 w-10",
        bordered: "bg-background border-default-300 h-10 w-10",
        underlined: "border-0 border-b-2 rounded-none h-10 w-10",
        glass: "bg-[#27272A] border-[#8C8C8C] h-10 w-10"
      },
      size: {
        sm: "h-8 w-8 text-xs",
        md: "h-10 w-10 text-sm",
        lg: "h-12 w-12 text-base",
        xl: "h-[70px] w-[81px] text-xl"
      },
      isInvalid: {
        true: "border-danger",
        false: ""
      }
    },
    defaultVariants: {
      variant: "bordered",
      size: "md",
      isInvalid: !1
    }
  }
), vl = m.forwardRef(
  ({ className: e, variant: t, size: n, length: r = 6, onComplete: o, isInvalid: a, ...s }, i) => {
    const { children: l, ...d } = s;
    return /* @__PURE__ */ c(
      Pr,
      {
        ref: i,
        maxLength: r,
        containerClassName: b(wl({ variant: t, size: n }), e),
        onComplete: o,
        ...d,
        render: ({ slots: f }) => /* @__PURE__ */ c(Ge, { children: f.map((u, g) => /* @__PURE__ */ c(m.Fragment, { children: /* @__PURE__ */ c(xl, { ...u, variant: t, size: n, isInvalid: a }) }, g)) }),
        ...s
      }
    );
  }
);
vl.displayName = "InputOtp";
function xl({ char: e, hasFakeCaret: t, isActive: n, variant: r, size: o, isInvalid: a, ...s }) {
  return /* @__PURE__ */ Y(
    "div",
    {
      className: b(
        yl({ variant: r, size: o, isInvalid: a }),
        n && r === "glass" ? "border-[#FBFBFB]" : n ? "z-10 ring-2 ring-ring ring-offset-background" : ""
      ),
      ...s,
      children: [
        e,
        t && /* @__PURE__ */ c("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ c("div", { className: "h-4 w-px animate-caret-blink bg-foreground duration-1000" }) })
      ]
    }
  );
}
const kl = ce(
  "peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-[var(--ui-switch-track-unchecked)]",
  {
    variants: {
      size: {
        sm: "h-4 w-7",
        md: "h-5 w-9",
        lg: "h-6 w-11"
      },
      color: {
        default: "data-[state=checked]:bg-primary",
        primary: "data-[state=checked]:bg-primary",
        warning: "data-[state=checked]:bg-warning",
        success: "data-[state=checked]:bg-success",
        danger: "data-[state=checked]:bg-danger"
      }
    },
    defaultVariants: {
      size: "md",
      color: "default"
    }
  }
), Ml = ce(
  "pointer-events-none block rounded-full bg-[var(--ui-switch-thumb)] shadow-lg ring-0 transition-transform",
  {
    variants: {
      size: {
        sm: "h-3 w-3 data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0",
        md: "h-4 w-4 data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0",
        lg: "h-5 w-5 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), Dl = m.forwardRef(
  ({ className: e, size: t, color: n, label: r, isSelected: o, onValueChange: a, checked: s, onCheckedChange: i, ...l }, d) => /* @__PURE__ */ Y("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ c(
      fn.Root,
      {
        ref: d,
        className: b(kl({ size: t, color: n }), e),
        checked: o ?? s,
        onCheckedChange: a ?? i,
        ...l,
        children: /* @__PURE__ */ c(fn.Thumb, { className: b(Ml({ size: t })) })
      }
    ),
    r && /* @__PURE__ */ c("label", { className: "text-sm", children: r })
  ] })
);
Dl.displayName = "Switch";
const Nl = Array.from({ length: 24 }, (e, t) => String(t).padStart(2, "0")), Sl = 5, Ol = 1, _n = (e) => Array.from({ length: Math.floor(60 / e) }, (t, n) => String(n * e).padStart(2, "0")), Vt = ({
  items: e,
  selected: t,
  onSelect: n
}) => {
  const r = Ke(null), o = Ke(/* @__PURE__ */ new Map());
  return Fn(() => {
    const a = o.current.get(t);
    a && r.current && a.scrollIntoView({ block: "center", behavior: "auto" });
  }, [t]), /* @__PURE__ */ c(
    "div",
    {
      ref: r,
      className: b(
        "flex flex-col overflow-y-auto h-[200px] p-1",
        "[scrollbar-width:thin] [scrollbar-color:var(--ui-scrollbar-thumb)_transparent]",
        "[&::-webkit-scrollbar]:w-1.5",
        "[&::-webkit-scrollbar-track]:bg-transparent",
        "[&::-webkit-scrollbar-thumb]:rounded-full",
        "[&::-webkit-scrollbar-thumb]:bg-[var(--ui-scrollbar-thumb)]"
      ),
      children: e.map((a) => /* @__PURE__ */ c(
        "button",
        {
          ref: (s) => {
            s && o.current.set(a, s);
          },
          type: "button",
          className: b(
            "shrink-0 w-10 h-8 rounded-md text-sm tabular-nums transition-colors",
            "hover:bg-default-100/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warning/70",
            a === t ? "bg-info text-[var(--ui-text-on-dark)]" : "text-default-700"
          ),
          onClick: () => n(a),
          children: a
        },
        a
      ))
    }
  );
}, Cl = m.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    value: r,
    onChange: o,
    placeholder: a = "Select time",
    disabled: s,
    minuteStep: i = Sl,
    showSeconds: l = !1,
    secondStep: d = Ol,
    ...f
  }, u) => {
    const [g, p] = Dt(!1), h = l ? "00:00:00" : "00:00", [D = "00", N = "00", y = "00"] = (r || h).split(":"), T = m.useMemo(() => _n(i), [i]), W = m.useMemo(() => _n(d), [d]), k = ($) => {
      o?.(l ? `${$}:${N}:${y}` : `${$}:${N}`);
    }, v = ($) => {
      o?.(l ? `${D}:${$}:${y}` : `${D}:${$}`);
    }, w = ($) => {
      o?.(`${D}:${N}:${$}`);
    };
    return /* @__PURE__ */ Y(Le.Root, { open: g, onOpenChange: p, children: [
      /* @__PURE__ */ c(Le.Trigger, { asChild: !0, children: /* @__PURE__ */ Y(
        "button",
        {
          ref: u,
          type: "button",
          className: b(
            xr({ variant: t, size: n }),
            !r && "text-muted-foreground",
            s && "opacity-50 cursor-not-allowed",
            e
          ),
          disabled: s,
          children: [
            /* @__PURE__ */ c("span", { className: "tabular-nums", children: r || a }),
            /* @__PURE__ */ c(Kr, { className: "ml-auto h-4 w-4 opacity-50" })
          ]
        }
      ) }),
      /* @__PURE__ */ c(Le.Portal, { children: /* @__PURE__ */ c(
        Le.Content,
        {
          className: "z-50 overflow-hidden rounded-md border border-default-200 bg-content1 p-0 shadow-small",
          align: "start",
          sideOffset: 8,
          children: /* @__PURE__ */ Y("div", { className: "flex divide-x divide-default-200", children: [
            /* @__PURE__ */ c(Vt, { items: Nl, selected: D, onSelect: k }),
            /* @__PURE__ */ c(Vt, { items: T, selected: N, onSelect: v }),
            l && /* @__PURE__ */ c(Vt, { items: W, selected: y, onSelect: w })
          ] })
        }
      ) })
    ] });
  }
);
Cl.displayName = "TimePicker";
const ln = (e, t = /* @__PURE__ */ new Date()) => {
  try {
    const r = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).formatToParts(t).find((l) => l.type === "timeZoneName")?.value ?? "GMT";
    if (/^(?:GMT|UTC)$/i.test(r)) return 0;
    const o = r.match(/^(?:GMT|UTC)([+-])(\d{1,2})(?::(\d{2}))?$/i);
    if (!o) return 0;
    const a = o[1] === "-" ? -1 : 1, s = Number(o[2]), i = o[3] ? Number(o[3]) : 0;
    return a * (s * 60 + i);
  } catch {
    return 0;
  }
}, Wl = (e, t = /* @__PURE__ */ new Date()) => {
  const n = ln(e, t), r = n >= 0 ? "+" : "-", o = Math.abs(n), a = Math.floor(o / 60), s = o % 60;
  return `UTC${r}${String(a).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}, Er = (e, t = /* @__PURE__ */ new Date()) => `(${Wl(e, t)}) ${e}`, Tn = (e) => e.startsWith("Europe/") ? 0 : e.startsWith("America/") ? 1 : e.startsWith("Asia/") ? 2 : e.startsWith("Africa/") ? 3 : e.startsWith("Australia/") || e.startsWith("Pacific/") ? 4 : e.startsWith("Atlantic/") || e.startsWith("Indian/") ? 5 : 6, _l = (e) => [...e].sort((t, n) => Tn(t) - Tn(n) || t.localeCompare(n))[0];
function Tl(e = /* @__PURE__ */ new Date()) {
  const t = /* @__PURE__ */ new Map();
  for (const n of Intl.supportedValuesOf("timeZone")) {
    const r = ln(n, e), o = t.get(r);
    o ? o.push(n) : t.set(r, [n]);
  }
  return [...t.entries()].sort((n, r) => n[0] - r[0]).map(([n, r]) => {
    const o = _l(r);
    return {
      value: o,
      label: Er(o, e),
      offsetMinutes: n
    };
  });
}
const Xe = Tl(), wc = ({
  value: e,
  onValueChange: t,
  label: n = "",
  placeholder: r = "Select timezone",
  searchPlaceholder: o = "Search timezone...",
  emptyText: a = "Not found",
  variant: s = "flat",
  disabled: i,
  className: l,
  inputClassName: d,
  dropdownClassName: f,
  isClearable: u
}) => {
  const g = et(() => {
    if (!e || Xe.find((y) => y.value === e)) return Xe;
    const h = ln(e), D = {
      value: e,
      label: Er(e),
      offsetMinutes: h
    }, N = Xe.findIndex((y) => y.offsetMinutes === h);
    if (N >= 0) {
      const y = Xe.slice();
      return y[N] = D, y;
    }
    return [...Xe, D].sort((y, T) => y.offsetMinutes - T.offsetMinutes);
  }, [e]);
  return /* @__PURE__ */ c(
    Cr,
    {
      options: g,
      value: e,
      onValueChange: t,
      label: n,
      placeholder: r,
      searchPlaceholder: o,
      emptyText: a,
      variant: s,
      disabled: i,
      className: l,
      inputClassName: d,
      dropdownClassName: f,
      isClearable: u
    }
  );
}, Pl = ce("", {
  variants: {
    variant: {
      light: "border-none",
      bordered: "border border-default-200 rounded-lg px-2",
      glass: "rounded-lg bg-[var(--ui-surface-glass)] backdrop-blur-sm shadow-[var(--ui-glass-shadow)] data-[state=open]:bg-[var(--ui-surface-glass-active)] data-[state=open]:shadow-none"
    }
  },
  defaultVariants: {
    variant: "light"
  }
}), yc = mt.Root, El = m.forwardRef(
  ({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ c(mt.Item, { ref: r, className: b(Pl({ variant: t, className: e })), ...n })
);
El.displayName = "AccordionItem";
const Yl = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ c(mt.Header, { className: "flex", children: /* @__PURE__ */ c(
  mt.Trigger,
  {
    ref: r,
    className: b(
      "flex flex-1 items-center justify-between transition-all",
      "data-[state=open]>[.accordion-chevron]:rotate-180",
      e
    ),
    ...n,
    children: t
  }
) }));
Yl.displayName = "AccordionTrigger";
const Fl = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ c(
  mt.Content,
  {
    ref: r,
    className: "overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...n,
    children: /* @__PURE__ */ c("div", { className: b("pb-2 pt-0", e), children: t })
  }
));
Fl.displayName = "AccordionContent";
const Pn = ce("flex items-center w-full", {
  variants: {
    orientation: {
      horizontal: "flex-row",
      vertical: "flex-col h-full w-auto"
    },
    textPosition: {
      start: "",
      center: "",
      end: ""
    }
  },
  defaultVariants: {
    orientation: "horizontal",
    textPosition: "center"
  }
}), qt = ({ className: e }) => /* @__PURE__ */ c("div", { className: b("shrink-0 border-border", e) }), $l = P.forwardRef(
  ({ className: e, orientation: t = "horizontal", textPosition: n = "center", lineClassName: r, children: o, ...a }, s) => {
    const i = t === "vertical", l = i ? "border-l grow" : "border-t grow";
    if (!o)
      return /* @__PURE__ */ c(
        "div",
        {
          ref: s,
          role: "separator",
          "aria-orientation": t ?? "horizontal",
          className: b(Pn({ orientation: t }), e),
          ...a,
          children: /* @__PURE__ */ c(qt, { className: b(l, "grow", r) })
        }
      );
    const d = n === "start" ? "grow-0 basis-[8%]" : "grow", f = n === "start" ? "grow" : n === "end" ? "grow-0 basis-[8%]" : "grow";
    return /* @__PURE__ */ Y(
      "div",
      {
        ref: s,
        role: "separator",
        "aria-orientation": t ?? "horizontal",
        className: b(Pn({ orientation: t }), e),
        ...a,
        children: [
          /* @__PURE__ */ c(qt, { className: b(l, d, r) }),
          /* @__PURE__ */ c("span", { className: b(
            "text-muted-foreground shrink-0 text-sm",
            i ? "py-2" : "px-3"
          ), children: o }),
          /* @__PURE__ */ c(qt, { className: b(l, f, r) })
        ]
      }
    );
  }
);
$l.displayName = "Divider";
const Il = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Y(ft.Root, { ref: r, className: b("relative overflow-hidden", e), ...n, children: [
  /* @__PURE__ */ c(ft.Viewport, { className: "h-full w-full rounded-[inherit]", children: t }),
  /* @__PURE__ */ c(Yr, {}),
  /* @__PURE__ */ c(ft.Corner, {})
] }));
Il.displayName = "ScrollArea";
const Yr = m.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ c(
  ft.ScrollAreaScrollbar,
  {
    ref: r,
    orientation: t,
    className: b(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ c(ft.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border hover:bg-border/80" })
  }
));
Yr.displayName = "ScrollBar";
const Fr = m.forwardRef(
  ({ className: e, size: t = "1rem", orientation: n = "vertical", fullSpace: r = !1, ...o }, a) => {
    const s = typeof t == "number" ? `${t}px` : t;
    return /* @__PURE__ */ c(
      "div",
      {
        ref: a,
        className: b("shrink-0", r && "flex-1", e),
        style: {
          [n === "vertical" ? "height" : "width"]: r ? void 0 : s
        },
        "aria-hidden": "true",
        ...o
      }
    );
  }
);
Fr.displayName = "Spacer";
const Gt = (e) => e != null && e !== !1, Rl = m.forwardRef(
  ({
    start: e,
    middle: t,
    end: n,
    className: r,
    startClassName: o,
    middleClassName: a,
    endClassName: s,
    withBorder: i = !0,
    withPadding: l = !0,
    ...d
  }, f) => {
    const u = Gt(e), g = Gt(t), p = Gt(n);
    if (!u && !g && !p)
      return null;
    const h = b(
      "w-full items-center gap-3",
      l && "py-4",
      i && "border-b border-input",
      r
    );
    return g ? /* @__PURE__ */ Y("div", { ref: f, className: b("grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]", h), ...d, children: [
      u ? /* @__PURE__ */ c("div", { className: b("min-w-0 flex flex-wrap items-center gap-3 justify-start", o), children: e }) : null,
      /* @__PURE__ */ c("div", { className: b("min-w-0 flex flex-wrap items-center gap-3 justify-center", a), children: t }),
      p ? /* @__PURE__ */ c("div", { className: b("min-w-0 flex flex-wrap items-center gap-3 justify-end", s), children: n }) : null
    ] }) : /* @__PURE__ */ Y("div", { ref: f, className: b("flex flex-wrap", h), ...d, children: [
      u ? /* @__PURE__ */ c("div", { className: b("min-w-0 flex flex-wrap items-center gap-3 justify-start", o), children: e }) : null,
      u && p ? /* @__PURE__ */ c(Fr, { fullSpace: !0 }) : null,
      p ? /* @__PURE__ */ c("div", { className: b("ml-auto min-w-0 max-w-full flex flex-wrap items-center gap-3 justify-end", s), children: n }) : null
    ] });
  }
);
Rl.displayName = "Toolbar";
const Bl = ce(
  "z-50 min-w-[8rem] overflow-hidden bg-[var(--ui-surface-dropdown)] backdrop-blur-[8px] text-foreground border border-[var(--ui-surface-glass-border)] shadow-2xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
  {
    variants: {
      size: {
        sm: "w-48 p-1",
        md: "w-64 p-1.5",
        lg: "w-72 p-2"
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-md",
        md: "rounded-xl",
        lg: "rounded-2xl",
        xl: "rounded-3xl"
      }
    },
    defaultVariants: {
      size: "md",
      radius: "lg"
    }
  }
), vc = ge.Root, xc = ge.Trigger, kc = ge.Group, Mc = ge.Portal, Al = m.forwardRef(({ className: e, size: t, radius: n, sideOffset: r = 8, ...o }, a) => /* @__PURE__ */ c(ge.Portal, { children: /* @__PURE__ */ c(
  ge.Content,
  {
    ref: a,
    sideOffset: r,
    className: b(Bl({ size: t, radius: n }), e),
    ...o
  }
) }));
Al.displayName = ge.Content.displayName;
const jl = m.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ c(
  ge.Item,
  {
    ref: r,
    className: b(
      "relative flex cursor-pointer select-none items-center rounded-xl px-3 py-2 text-sm outline-none transition-colors focus:bg-default-200/60 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
jl.displayName = ge.Item.displayName;
const zl = m.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ c(
  ge.Label,
  {
    ref: r,
    className: b("px-3 py-2 text-sm font-semibold text-default-400", t && "pl-8", e),
    ...n
  }
));
zl.displayName = ge.Label.displayName;
const Hl = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  ge.Separator,
  {
    ref: n,
    className: b("mx-2 my-1 h-px bg-default-300/60", e),
    ...t
  }
));
Hl.displayName = ge.Separator.displayName;
const Dc = ge.Arrow, Nc = ge.Content, Ll = ce(
  "inline-flex items-center transition-colors underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
  {
    variants: {
      size: {
        sm: "text-sm",
        md: "text-base",
        lg: "text-lg"
      },
      color: {
        foreground: "text-foreground",
        primary: "text-primary",
        warning: "text-warning",
        danger: "text-danger"
      }
    },
    defaultVariants: {
      size: "md",
      color: "primary"
    }
  }
), Vl = m.forwardRef(({ className: e, size: t, color: n, ...r }, o) => /* @__PURE__ */ c("a", { ref: o, className: b(Ll({ size: t, color: n }), e), ...r }));
Vl.displayName = "Link";
const $r = m.createContext(void 0), ql = m.forwardRef(
  ({
    className: e,
    variant: t = "solid",
    color: n = "default",
    selectionMode: r = "single",
    selectedKeys: o,
    defaultSelectedKeys: a,
    disabledKeys: s,
    onSelectionChange: i,
    itemClasses: l,
    classNames: d,
    as: f = "div",
    hideSelectedIcon: u,
    ...g
  }, p) => {
    const [h, D] = m.useState(a || /* @__PURE__ */ new Set()), N = o ?? h, y = (k) => {
      if (s instanceof Set && s.has(k)) return;
      let v;
      if (r === "multiple") {
        const w = N instanceof Set ? new Set(Array.from(N)) : /* @__PURE__ */ new Set();
        v = new Set(w), v.has(k) ? v.delete(k) : v.add(k);
      } else r === "single" ? v = /* @__PURE__ */ new Set([k]) : v = /* @__PURE__ */ new Set();
      o || D(v), i?.(v);
    }, T = {
      solid: "bg-content1 border border-default-200",
      flat: "bg-default-100",
      light: "bg-transparent"
    }, W = {
      default: "",
      primary: "",
      secondary: "",
      success: "",
      warning: "",
      danger: ""
    };
    return /* @__PURE__ */ c($r.Provider, { value: { itemClasses: l }, children: /* @__PURE__ */ c(
      f,
      {
        ref: p,
        role: "listbox",
        className: b(
          "divide-y divide-default-200 rounded-lg overflow-hidden",
          T[t],
          W[n],
          d?.list,
          e
        ),
        ...g,
        children: m.Children.map(g.children, (k) => {
          if (m.isValidElement(k)) {
            const v = k.key, w = N instanceof Set && (v ? N.has(v) : !1);
            return m.cloneElement(k, {
              isSelected: w,
              isDisabled: s instanceof Set && (v ? s.has(v) : !1),
              onSelect: y
            });
          }
          return k;
        })
      }
    ) });
  }
);
ql.displayName = "Listbox";
const Gl = m.forwardRef(
  ({
    className: e,
    title: t,
    description: n,
    startContent: r,
    endContent: o,
    isSelected: a,
    isDisabled: s,
    textValue: i,
    onSelect: l,
    classNames: d,
    children: f,
    ...u
  }, g) => {
    const h = { ...m.useContext($r)?.itemClasses, ...d };
    return /* @__PURE__ */ Y(
      "div",
      {
        ref: g,
        role: "option",
        tabIndex: s ? -1 : 0,
        "aria-selected": a,
        "aria-disabled": s,
        onClick: () => l?.(u.key),
        onKeyDown: (D) => {
          (D.key === "Enter" || D.key === " ") && (D.preventDefault(), l?.(u.key));
        },
        className: b(
          "group flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors",
          s && "opacity-50 cursor-not-allowed",
          a && "bg-primary/10 border-l-2 border-l-primary",
          !a && "hover:bg-default-100",
          h?.base,
          e
        ),
        ...u,
        children: [
          r && /* @__PURE__ */ c("span", { className: b("flex-shrink-0", h?.startContent), children: r }),
          /* @__PURE__ */ Y("div", { className: "flex-1 min-w-0", children: [
            t && /* @__PURE__ */ c("div", { className: b("font-medium truncate", h?.title), children: t }),
            n && /* @__PURE__ */ c("div", { className: b("text-sm text-default-500 truncate", h?.description), children: n }),
            !t && f
          ] }),
          o && /* @__PURE__ */ c("span", { className: b("flex-shrink-0 ml-auto", h?.endContent), children: o })
        ]
      }
    );
  }
);
Gl.displayName = "ListboxItem";
const Ul = m.forwardRef(
  ({ className: e, title: t, showDivider: n = !0, classNames: r, children: o }, a) => /* @__PURE__ */ Y("div", { ref: a, className: b("overflow-hidden", r?.base, e), children: [
    t && /* @__PURE__ */ c("div", { className: b("px-4 py-2 text-xs font-semibold text-default-500", r?.title), children: t }),
    /* @__PURE__ */ c("div", { className: b("", r?.group), children: o }),
    n && /* @__PURE__ */ c("div", { className: "border-t border-default-200" })
  ] })
);
Ul.displayName = "ListboxSection";
const Zl = [10, 25, 50, 100], En = {
  "--color-foreground": "var(--color-warning)",
  "--color-background": "var(--color-warning-foreground)"
}, Ir = () => /* @__PURE__ */ c("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 19l-7-7 7-7" }) }), Rr = () => /* @__PURE__ */ c("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ c("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 5l7 7-7 7" }) }), Yn = ({
  page: e,
  totalPages: t,
  size: n,
  isCompact: r,
  showControls: o,
  pagerButtonVariant: a,
  pagerButtonColor: s,
  onPageChange: i
}) => {
  const l = {
    sm: "h-7 min-w-7 text-xs",
    md: "h-8 min-w-8 text-sm",
    lg: "h-10 min-w-10 text-base"
  }, d = {
    sm: "sm",
    md: "md",
    lg: "lg"
  }, f = 2;
  let u = e - f, g = e + f;
  u < 1 && (g = Math.min(t, g + (1 - u)), u = 1), g > t && (u = Math.max(1, u - (g - t)), g = t);
  const p = r ? [e] : Array.from({ length: g - u + 1 }, (N, y) => u + y), h = a === "light" && s === "default", D = b(
    Hn({
      variant: a,
      color: s,
      size: d[n],
      isIconOnly: !0
    }),
    "flex items-center justify-center rounded-lg font-medium transition-colors",
    l[n]
  );
  return /* @__PURE__ */ Y("div", { className: "flex items-center gap-1", children: [
    o && /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: b(
          D,
          h && "text-default-400 hover:text-foreground hover:bg-default-200",
          "disabled:opacity-30"
        ),
        onClick: () => i(e - 1),
        disabled: e <= 1,
        children: /* @__PURE__ */ c(Ir, {})
      }
    ),
    !r && p.length && p[0] > 1 && /* @__PURE__ */ Y(Ge, { children: [
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          className: b(
            D,
            h && "hover:bg-default-200 text-default-400 hover:text-foreground"
          ),
          onClick: () => i(1),
          children: "1"
        }
      ),
      p[0] > 2 && /* @__PURE__ */ c("span", { className: b(D, "text-default-500 cursor-default"), children: "…" })
    ] }),
    p.map((N) => /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: b(
          D,
          N === e ? h ? "bg-foreground text-background" : "ring-2 ring-warning" : h ? "hover:bg-default-200 text-default-400 hover:text-foreground" : ""
        ),
        onClick: () => i(N),
        children: N
      },
      N
    )),
    !r && p.length && p[p.length - 1] < t && /* @__PURE__ */ Y(Ge, { children: [
      p[p.length - 1] < t - 1 && /* @__PURE__ */ c("span", { className: b(D, "text-default-500 cursor-default"), children: "…" }),
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          className: b(
            D,
            h && "hover:bg-default-200 text-default-400 hover:text-foreground"
          ),
          onClick: () => i(t),
          children: t
        }
      )
    ] }),
    r && /* @__PURE__ */ Y("span", { className: b(D, "text-default-400 px-1 cursor-default"), children: [
      "/ ",
      t
    ] }),
    o && /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: b(
          D,
          h && "text-default-400 hover:text-foreground hover:bg-default-200",
          "disabled:opacity-30"
        ),
        onClick: () => i(e + 1),
        disabled: e >= t,
        children: /* @__PURE__ */ c(Rr, {})
      }
    )
  ] });
}, Sc = ({
  page: e,
  limit: t,
  total: n,
  size: r = "md",
  isCompact: o = !1,
  showControls: a = !0,
  className: s,
  onChange: i,
  onPageChange: l,
  onLimitChange: d,
  limitOptions: f = Zl,
  rowsLabel: u = "Rows",
  previousLabel: g = "Previous",
  nextLabel: p = "Next",
  showPageControls: h,
  showRowsSelector: D,
  scrollToTopOnPageChange: N = !1,
  variants: y
}) => {
  const T = l ?? i, W = Math.max(1, Number(t) || 1), k = Math.max(1, Math.ceil(n / W)), v = Math.min(Math.max(1, Number(e) || 1), k), w = y?.controlsButtonVariant ?? "light", $ = y?.controlsButtonColor ?? "default", L = y?.pagerButtonVariant ?? "light", B = y?.pagerButtonColor ?? "default", I = y?.rowsSelectVariant ?? "bordered", R = w === "light" && $ === "default", X = et(() => {
    const x = f.filter((C) => Number.isFinite(C) && C > 0);
    return x.includes(W) || x.push(W), [...new Set(x)].sort((C, F) => C - F);
  }, [f, W]), V = (x) => {
    if (!T) return;
    const C = Math.min(Math.max(1, x), k);
    C !== v && (N && typeof window < "u" && window.scrollTo({ top: 0, behavior: "smooth" }), T(C));
  };
  if (o)
    return /* @__PURE__ */ c("div", { className: b("flex items-center gap-1", s), style: En, children: /* @__PURE__ */ c(
      Yn,
      {
        page: v,
        totalPages: k,
        size: r,
        isCompact: !0,
        showControls: a,
        pagerButtonVariant: L,
        pagerButtonColor: B,
        onPageChange: V
      }
    ) });
  const O = h ?? !0, _ = D ?? !0, M = v > 1, S = v < k;
  return /* @__PURE__ */ Y("div", { className: b("flex w-full flex-col gap-3 md:flex-row md:items-center md:justify-between", s), children: [
    O ? /* @__PURE__ */ c(
      ht,
      {
        variant: w,
        color: $,
        size: "lg",
        disabled: !M,
        onClick: () => V(v - 1),
        startContent: /* @__PURE__ */ c(Ir, {}),
        className: b(
          "justify-start gap-2 px-3",
          R && "text-default-500 hover:text-warning disabled:text-default-500/40"
        ),
        children: g
      }
    ) : /* @__PURE__ */ c("div", { className: "hidden md:block" }),
    O ? /* @__PURE__ */ c("div", { className: "order-3 flex justify-center md:order-2", style: En, children: /* @__PURE__ */ c(
      Yn,
      {
        page: v,
        totalPages: k,
        size: r,
        isCompact: !1,
        showControls: !1,
        pagerButtonVariant: L,
        pagerButtonColor: B,
        onPageChange: V
      }
    ) }) : null,
    /* @__PURE__ */ Y("div", { className: "order-2 flex items-center justify-end gap-3 md:order-3", children: [
      O ? /* @__PURE__ */ c(
        ht,
        {
          variant: w,
          color: $,
          size: "md",
          disabled: !S,
          onClick: () => V(v + 1),
          endContent: /* @__PURE__ */ c(Rr, {}),
          className: b(
            "justify-end gap-2 px-3",
            R && "text-warning disabled:text-default-500/40"
          ),
          children: p
        }
      ) : null,
      _ && d ? /* @__PURE__ */ Y("div", { className: "flex items-center gap-2 border-l border-input pl-3", children: [
        /* @__PURE__ */ Y("span", { className: "text-sm text-default-400", children: [
          u,
          ":"
        ] }),
        /* @__PURE__ */ c(
          on,
          {
            value: String(W),
            onValueChange: (x) => {
              const C = Number(x);
              Number.isFinite(C) && C > 0 && C !== W && d(C);
            },
            className: "w-[84px] shrink-0",
            size: "sm",
            variant: I,
            children: X.map((x) => /* @__PURE__ */ c(an, { value: String(x), children: x }, x))
          }
        )
      ] }) : null
    ] })
  ] });
}, Ql = ce("inline-flex items-center rounded-lg bg-content1 p-1 gap-1", {
  variants: {
    size: {
      sm: "h-9 text-xs",
      md: "h-10 text-sm",
      lg: "h-11 text-base"
    },
    variant: {
      default: "",
      admin: "bg-transparent border border-input p-0.5 gap-0.5",
      "pill-glow": "bg-[var(--ui-surface-glass)] [&_[data-state=active]]:[background:var(--ui-glow-gradient)] [&_[data-state=active]]:shadow-[var(--ui-glow-shadow)] [&_[data-state=active]]:text-[var(--ui-glow-foreground)]"
    }
  },
  defaultVariants: {
    size: "md",
    variant: "default"
  }
}), Xl = ce(
  "inline-flex w-full items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "text-default-400 hover:text-default-200 data-[state=active]:bg-default/40 data-[state=active]:text-foreground",
        admin: "w-auto border border-transparent bg-transparent text-default-500 hover:text-default hover:bg-default/5 data-[state=active]:border-input data-[state=active]:bg-default/10 data-[state=active]:text-default",
        glow: "text-default-400 hover:text-default-200 data-[state=active]:[background:var(--ui-glow-gradient)] data-[state=active]:shadow-[var(--ui-glow-shadow)] data-[state=active]:text-[var(--ui-glow-foreground)]"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Oc = St.Root, Jl = m.forwardRef(
  ({ className: e, size: t, variant: n, ...r }, o) => /* @__PURE__ */ c(St.List, { ref: o, className: b(Ql({ size: t, variant: n, className: e })), ...r })
);
Jl.displayName = "TabsList";
const Kl = m.forwardRef(
  ({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ c(St.Trigger, { ref: r, className: b(Xl({ variant: t, className: e })), ...n })
);
Kl.displayName = "TabsTrigger";
const ec = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  St.Content,
  {
    ref: n,
    className: b("focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2", e),
    ...t
  }
));
ec.displayName = "TabsContent";
const tc = ce(
  "relative inline-flex items-center justify-center shrink-0 overflow-hidden font-medium",
  {
    variants: {
      size: {
        sm: "h-8 w-8 text-xs",
        md: "h-10 w-10 text-sm",
        lg: "h-12 w-12 text-base",
        xl: "h-16 w-16 text-lg"
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
        full: "rounded-full"
      },
      color: {
        default: "bg-default-100 text-default-foreground",
        primary: "bg-primary/20 text-primary",
        secondary: "bg-secondary/20 text-secondary",
        success: "bg-success/20 text-success",
        warning: "bg-warning/20 text-warning",
        danger: "bg-danger/20 text-danger"
      }
    },
    defaultVariants: {
      size: "md",
      radius: "full",
      color: "default"
    }
  }
), nc = m.forwardRef(
  ({
    className: e,
    size: t,
    radius: n,
    colorVariant: r = "default",
    src: o,
    alt: a,
    isBordered: s,
    icon: i,
    fallback: l,
    name: d,
    children: f,
    ...u
  }, g) => {
    const p = l || (d ? rc(d) : f || i || "?");
    return /* @__PURE__ */ c(
      "div",
      {
        className: b(
          "relative inline-flex",
          s && b(
            "p-0.5",
            t === "sm" && "ring-2 ring-default-200",
            t === "md" && "ring-2 ring-default-200",
            t === "lg" && "ring-2 ring-default-200",
            t === "xl" && "ring-2 ring-default-200"
          )
        ),
        children: /* @__PURE__ */ Y(
          It.Root,
          {
            ref: g,
            className: b(tc({ size: t, radius: n, color: r }), e),
            ...u,
            children: [
              o && /* @__PURE__ */ c(It.Image, { src: o, alt: a || d || "avatar", className: "h-full w-full object-cover" }),
              /* @__PURE__ */ c(It.Fallback, { className: "flex h-full w-full items-center justify-center", children: p })
            ]
          }
        )
      }
    );
  }
);
nc.displayName = "Avatar";
function rc(e) {
  if (!e) return "?";
  const t = e.trim().split(/\s+/);
  return t.length === 0 ? "?" : t.length === 1 ? t[0]?.charAt(0)?.toUpperCase() ?? "?" : ((t[0]?.charAt(0) ?? "") + (t[t.length - 1]?.charAt(0) ?? "")).toUpperCase() || "?";
}
export {
  yc as Accordion,
  Fl as AccordionContent,
  El as AccordionItem,
  Yl as AccordionTrigger,
  nc as Avatar,
  ht as Button,
  _t as Calendar,
  ro as Card,
  ao as CardBody,
  so as CardFooter,
  oo as CardHeader,
  qo as Checkbox,
  co as Chip,
  Cr as Combobox,
  Xi as DatePicker,
  $l as Divider,
  vc as DropdownMenu,
  Dc as DropdownMenuArrow,
  Al as DropdownMenuContent,
  kc as DropdownMenuGroup,
  jl as DropdownMenuItem,
  zl as DropdownMenuLabel,
  Mc as DropdownMenuPortal,
  Nc as DropdownMenuRawContent,
  Hl as DropdownMenuSeparator,
  xc as DropdownMenuTrigger,
  rl as Form,
  Ji as GlassDatePicker,
  Ki as GlassRangeDatePicker,
  Or as Input,
  vl as InputOtp,
  Vl as Link,
  ql as Listbox,
  Gl as ListboxItem,
  Ul as ListboxSection,
  fc as Modal,
  So as ModalBody,
  hc as ModalClose,
  xo as ModalContent,
  No as ModalDescription,
  Mo as ModalFooter,
  ko as ModalHeader,
  An as ModalOverlay,
  vo as ModalPortal,
  Do as ModalTitle,
  mc as ModalTrigger,
  Sc as Pagination,
  Il as ScrollArea,
  Yr as ScrollBar,
  on as Select,
  an as SelectItem,
  Fr as Spacer,
  Co as Spinner,
  Dl as Switch,
  uo as Table,
  mo as TableBody,
  wo as TableCaption,
  bo as TableCell,
  ho as TableFooter,
  go as TableHead,
  fo as TableHeader,
  po as TableRow,
  Oc as Tabs,
  ec as TabsContent,
  Jl as TabsList,
  Kl as TabsTrigger,
  Cl as TimePicker,
  wc as TimezoneCombobox,
  gc as ToastProvider,
  Rl as Toolbar,
  Ho as Tooltip,
  zn as TooltipContent,
  bc as TooltipProvider,
  jo as TooltipRoot,
  zo as TooltipTrigger,
  Pl as accordionItemVariants,
  pc as addToast,
  Hn as buttonVariants,
  Lo as checkboxVariants,
  io as chipVariants,
  Rt as closeToast,
  b as cn,
  Pn as dividerVariants,
  Bl as dropdownMenuContentVariants,
  Er as formatTimezoneLabel,
  Wl as formatUtcOffsetPrefix,
  Nr as getDayPickerLocaleOptions,
  rc as getInitials,
  ln as getTimezoneOffsetMinutes,
  Rn as glassCalendarClassNames,
  In as glassPanel,
  el as inputVariants,
  Ll as linkVariants,
  Gi as selectTriggerVariants,
  Oo as spinnerVariants,
  Ql as tabsListVariants
};
